var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundsHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 397,
    viewBox: "0 0 355 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.04 343.624C132.991 344.216 133.27 344.743 133.714 345.072C133.944 344.101 134.158 343.115 134.355 342.128C133.648 342.276 133.106 342.868 133.056 343.608L133.04 343.624Z",
    fill: "url(#paint0_linear_935_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.04 343.624C132.991 344.216 133.27 344.743 133.714 345.072C133.944 344.101 134.158 343.115 134.355 342.128C133.648 342.276 133.106 342.868 133.056 343.608L133.04 343.624Z",
    fill: "url(#paint1_linear_935_10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.04 343.624C132.991 344.216 133.27 344.743 133.714 345.072C133.944 344.101 134.158 343.115 134.355 342.128C133.648 342.276 133.106 342.868 133.056 343.608L133.04 343.624Z",
    fill: "url(#paint2_linear_935_10)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.109 329.499C134.043 330.387 134.684 331.16 135.572 331.258C135.605 330.156 135.622 329.071 135.605 327.969C134.816 328.052 134.175 328.676 134.125 329.482L134.109 329.499Z",
    fill: "url(#paint3_linear_935_10)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.109 329.499C134.043 330.387 134.684 331.16 135.572 331.258C135.605 330.156 135.622 329.071 135.605 327.969C134.816 328.052 134.175 328.676 134.125 329.482L134.109 329.499Z",
    fill: "url(#paint4_linear_935_10)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.109 329.499C134.043 330.387 134.684 331.16 135.572 331.258C135.605 330.156 135.622 329.071 135.605 327.969C134.816 328.052 134.175 328.676 134.125 329.482L134.109 329.499Z",
    fill: "url(#paint5_linear_935_10)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.917 362.667C124.013 362.601 123.207 363.276 123.141 364.197C123.076 365.117 123.75 365.907 124.671 365.973C124.703 365.973 124.736 365.973 124.769 365.973C125.279 365.183 125.772 364.361 126.266 363.555C126.002 363.078 125.526 362.716 124.934 362.684L124.917 362.667Z",
    fill: "url(#paint6_linear_935_10)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.917 362.667C124.013 362.601 123.207 363.276 123.141 364.197C123.076 365.117 123.75 365.907 124.671 365.973C124.703 365.973 124.736 365.973 124.769 365.973C125.279 365.183 125.772 364.361 126.266 363.555C126.002 363.078 125.526 362.716 124.934 362.684L124.917 362.667Z",
    fill: "url(#paint7_linear_935_10)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.917 362.667C124.013 362.601 123.207 363.276 123.141 364.197C123.076 365.117 123.75 365.907 124.671 365.973C124.703 365.973 124.736 365.973 124.769 365.973C125.279 365.183 125.772 364.361 126.266 363.555C126.002 363.078 125.526 362.716 124.934 362.684L124.917 362.667Z",
    fill: "url(#paint8_linear_935_10)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 350.054C124.144 350.959 124.819 351.764 125.739 351.83C126.644 351.896 127.45 351.222 127.515 350.301C127.581 349.396 126.907 348.591 125.986 348.525C125.082 348.459 124.276 349.133 124.21 350.054Z",
    fill: "url(#paint9_linear_935_10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 350.054C124.144 350.959 124.819 351.764 125.739 351.83C126.644 351.896 127.45 351.222 127.515 350.301C127.581 349.396 126.907 348.591 125.986 348.525C125.082 348.459 124.276 349.133 124.21 350.054Z",
    fill: "url(#paint10_linear_935_10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 350.054C124.144 350.959 124.819 351.764 125.739 351.83C126.644 351.896 127.45 351.222 127.515 350.301C127.581 349.396 126.907 348.591 125.986 348.525C125.082 348.459 124.276 349.133 124.21 350.054Z",
    fill: "url(#paint11_linear_935_10)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.279 335.928C125.213 336.833 125.887 337.639 126.808 337.704C127.712 337.77 128.518 337.096 128.584 336.175C128.65 335.271 127.975 334.465 127.055 334.399C126.15 334.333 125.345 335.008 125.279 335.928Z",
    fill: "url(#paint12_linear_935_10)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.279 335.928C125.213 336.833 125.887 337.639 126.808 337.704C127.712 337.77 128.518 337.096 128.584 336.175C128.65 335.271 127.975 334.465 127.055 334.399C126.15 334.333 125.345 335.008 125.279 335.928Z",
    fill: "url(#paint13_linear_935_10)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.279 335.928C125.213 336.833 125.887 337.639 126.808 337.704C127.712 337.77 128.518 337.096 128.584 336.175C128.65 335.271 127.975 334.465 127.055 334.399C126.15 334.333 125.345 335.008 125.279 335.928Z",
    fill: "url(#paint14_linear_935_10)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.636 322.049C129.702 321.145 129.028 320.339 128.107 320.273C127.203 320.207 126.397 320.882 126.331 321.803C126.266 322.707 126.94 323.513 127.861 323.579C128.765 323.644 129.571 322.97 129.636 322.049Z",
    fill: "url(#paint15_linear_935_10)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.636 322.049C129.702 321.145 129.028 320.339 128.107 320.273C127.203 320.207 126.397 320.882 126.331 321.803C126.266 322.707 126.94 323.513 127.861 323.579C128.765 323.644 129.571 322.97 129.636 322.049Z",
    fill: "url(#paint16_linear_935_10)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M129.636 322.049C129.702 321.145 129.028 320.339 128.107 320.273C127.203 320.207 126.397 320.882 126.331 321.803C126.266 322.707 126.94 323.513 127.861 323.579C128.765 323.644 129.571 322.97 129.636 322.049Z",
    fill: "url(#paint17_linear_935_10)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.705 307.923C130.771 307.019 130.097 306.213 129.176 306.147C128.272 306.082 127.466 306.756 127.4 307.677C127.334 308.581 128.009 309.387 128.929 309.453C129.834 309.518 130.639 308.844 130.705 307.923Z",
    fill: "url(#paint18_linear_935_10)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.705 307.923C130.771 307.019 130.097 306.213 129.176 306.147C128.272 306.082 127.466 306.756 127.4 307.677C127.334 308.581 128.009 309.387 128.929 309.453C129.834 309.518 130.639 308.844 130.705 307.923Z",
    fill: "url(#paint19_linear_935_10)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.705 307.923C130.771 307.019 130.097 306.213 129.176 306.147C128.272 306.082 127.466 306.756 127.4 307.677C127.334 308.581 128.009 309.387 128.929 309.453C129.834 309.518 130.639 308.844 130.705 307.923Z",
    fill: "url(#paint20_linear_935_10)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.246 370.61C114.18 371.514 114.854 372.32 115.775 372.386C116.679 372.452 117.485 371.777 117.551 370.857C117.616 369.952 116.942 369.146 116.021 369.081C115.117 369.015 114.311 369.689 114.246 370.61Z",
    fill: "url(#paint21_linear_935_10)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.246 370.61C114.18 371.514 114.854 372.32 115.775 372.386C116.679 372.452 117.485 371.777 117.551 370.857C117.616 369.952 116.942 369.146 116.021 369.081C115.117 369.015 114.311 369.689 114.246 370.61Z",
    fill: "url(#paint22_linear_935_10)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.246 370.61C114.18 371.514 114.854 372.32 115.775 372.386C116.679 372.452 117.485 371.777 117.551 370.857C117.616 369.952 116.942 369.146 116.021 369.081C115.117 369.015 114.311 369.689 114.246 370.61Z",
    fill: "url(#paint23_linear_935_10)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.314 356.484C115.249 357.388 115.923 358.194 116.844 358.26C117.748 358.326 118.554 357.652 118.62 356.731C118.685 355.826 118.011 355.02 117.09 354.955C116.186 354.889 115.38 355.563 115.314 356.484Z",
    fill: "url(#paint24_linear_935_10)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.314 356.484C115.249 357.388 115.923 358.194 116.844 358.26C117.748 358.326 118.554 357.652 118.62 356.731C118.685 355.826 118.011 355.02 117.09 354.955C116.186 354.889 115.38 355.563 115.314 356.484Z",
    fill: "url(#paint25_linear_935_10)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.314 356.484C115.249 357.388 115.923 358.194 116.844 358.26C117.748 358.326 118.554 357.652 118.62 356.731C118.685 355.826 118.011 355.02 117.09 354.955C116.186 354.889 115.38 355.563 115.314 356.484Z",
    fill: "url(#paint26_linear_935_10)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.383 342.358C116.318 343.263 116.992 344.068 117.913 344.134C118.817 344.2 119.623 343.526 119.688 342.605C119.754 341.7 119.08 340.895 118.159 340.829C117.255 340.763 116.449 341.437 116.383 342.358Z",
    fill: "url(#paint27_linear_935_10)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M116.383 342.358C116.318 343.263 116.992 344.068 117.913 344.134C118.817 344.2 119.623 343.526 119.688 342.605C119.754 341.7 119.08 340.895 118.159 340.829C117.255 340.763 116.449 341.437 116.383 342.358Z",
    fill: "url(#paint28_linear_935_10)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M116.383 342.358C116.318 343.263 116.992 344.068 117.913 344.134C118.817 344.2 119.623 343.526 119.688 342.605C119.754 341.7 119.08 340.895 118.159 340.829C117.255 340.763 116.449 341.437 116.383 342.358Z",
    fill: "url(#paint29_linear_935_10)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.757 328.479C120.823 327.575 120.149 326.769 119.228 326.703C118.324 326.637 117.518 327.311 117.452 328.232C117.386 329.137 118.061 329.943 118.981 330.008C119.886 330.074 120.691 329.4 120.757 328.479Z",
    fill: "url(#paint30_linear_935_10)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M120.757 328.479C120.823 327.575 120.149 326.769 119.228 326.703C118.324 326.637 117.518 327.311 117.452 328.232C117.386 329.137 118.061 329.943 118.981 330.008C119.886 330.074 120.691 329.4 120.757 328.479Z",
    fill: "url(#paint31_linear_935_10)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.757 328.479C120.823 327.575 120.149 326.769 119.228 326.703C118.324 326.637 117.518 327.311 117.452 328.232C117.386 329.137 118.061 329.943 118.981 330.008C119.886 330.074 120.691 329.4 120.757 328.479Z",
    fill: "url(#paint32_linear_935_10)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.826 314.353C121.892 313.449 121.217 312.643 120.297 312.577C119.392 312.511 118.587 313.186 118.521 314.107C118.455 315.011 119.129 315.817 120.05 315.883C120.954 315.948 121.76 315.274 121.826 314.353Z",
    fill: "url(#paint33_linear_935_10)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.826 314.353C121.892 313.449 121.217 312.643 120.297 312.577C119.392 312.511 118.587 313.186 118.521 314.107C118.455 315.011 119.129 315.817 120.05 315.883C120.954 315.948 121.76 315.274 121.826 314.353Z",
    fill: "url(#paint34_linear_935_10)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M121.826 314.353C121.892 313.449 121.217 312.643 120.297 312.577C119.392 312.511 118.587 313.186 118.521 314.107C118.455 315.011 119.129 315.817 120.05 315.883C120.954 315.948 121.76 315.274 121.826 314.353Z",
    fill: "url(#paint35_linear_935_10)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.895 300.227C122.96 299.323 122.286 298.517 121.365 298.451C120.461 298.386 119.655 299.06 119.59 299.981C119.524 300.885 120.198 301.691 121.119 301.757C122.023 301.823 122.829 301.148 122.895 300.227Z",
    fill: "url(#paint36_linear_935_10)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M122.895 300.227C122.96 299.323 122.286 298.517 121.365 298.451C120.461 298.386 119.655 299.06 119.59 299.981C119.524 300.885 120.198 301.691 121.119 301.757C122.023 301.823 122.829 301.148 122.895 300.227Z",
    fill: "url(#paint37_linear_935_10)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M122.895 300.227C122.96 299.323 122.286 298.517 121.365 298.451C120.461 298.386 119.655 299.06 119.59 299.981C119.524 300.885 120.198 301.691 121.119 301.757C122.023 301.823 122.829 301.148 122.895 300.227Z",
    fill: "url(#paint38_linear_935_10)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105.399 377.056C105.334 377.961 106.008 378.766 106.929 378.832C107.833 378.898 108.639 378.224 108.704 377.303C108.77 376.398 108.096 375.593 107.175 375.527C106.271 375.461 105.465 376.135 105.399 377.056Z",
    fill: "url(#paint39_linear_935_10)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.399 377.056C105.334 377.961 106.008 378.766 106.929 378.832C107.833 378.898 108.639 378.224 108.704 377.303C108.77 376.398 108.096 375.593 107.175 375.527C106.271 375.461 105.465 376.135 105.399 377.056Z",
    fill: "url(#paint40_linear_935_10)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M105.399 377.056C105.334 377.961 106.008 378.766 106.929 378.832C107.833 378.898 108.639 378.224 108.704 377.303C108.77 376.398 108.096 375.593 107.175 375.527C106.271 375.461 105.465 376.135 105.399 377.056Z",
    fill: "url(#paint41_linear_935_10)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M106.484 362.93C106.419 363.835 107.093 364.641 108.014 364.706C108.918 364.772 109.724 364.098 109.789 363.177C109.855 362.273 109.181 361.467 108.26 361.401C107.356 361.335 106.55 362.009 106.484 362.93Z",
    fill: "url(#paint42_linear_935_10)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.484 362.93C106.419 363.835 107.093 364.641 108.014 364.706C108.918 364.772 109.724 364.098 109.789 363.177C109.855 362.273 109.181 361.467 108.26 361.401C107.356 361.335 106.55 362.009 106.484 362.93Z",
    fill: "url(#paint43_linear_935_10)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M106.484 362.93C106.419 363.835 107.093 364.641 108.014 364.706C108.918 364.772 109.724 364.098 109.789 363.177C109.855 362.273 109.181 361.467 108.26 361.401C107.356 361.335 106.55 362.009 106.484 362.93Z",
    fill: "url(#paint44_linear_935_10)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M107.553 348.804C107.487 349.709 108.162 350.515 109.082 350.58C109.987 350.646 110.793 349.972 110.858 349.051C110.924 348.147 110.25 347.341 109.329 347.275C108.425 347.209 107.619 347.884 107.553 348.804Z",
    fill: "url(#paint45_linear_935_10)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.553 348.804C107.487 349.709 108.162 350.515 109.082 350.58C109.987 350.646 110.793 349.972 110.858 349.051C110.924 348.147 110.25 347.341 109.329 347.275C108.425 347.209 107.619 347.884 107.553 348.804Z",
    fill: "url(#paint46_linear_935_10)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.553 348.804C107.487 349.709 108.162 350.515 109.082 350.58C109.987 350.646 110.793 349.972 110.858 349.051C110.924 348.147 110.25 347.341 109.329 347.275C108.425 347.209 107.619 347.884 107.553 348.804Z",
    fill: "url(#paint47_linear_935_10)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.622 334.679C108.556 335.583 109.23 336.389 110.151 336.455C111.056 336.52 111.861 335.846 111.927 334.925C111.993 334.021 111.319 333.215 110.398 333.149C109.494 333.083 108.688 333.758 108.622 334.679Z",
    fill: "url(#paint48_linear_935_10)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M108.622 334.679C108.556 335.583 109.23 336.389 110.151 336.455C111.056 336.52 111.861 335.846 111.927 334.925C111.993 334.021 111.319 333.215 110.398 333.149C109.494 333.083 108.688 333.758 108.622 334.679Z",
    fill: "url(#paint49_linear_935_10)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.622 334.679C108.556 335.583 109.23 336.389 110.151 336.455C111.056 336.52 111.861 335.846 111.927 334.925C111.993 334.021 111.319 333.215 110.398 333.149C109.494 333.083 108.688 333.758 108.622 334.679Z",
    fill: "url(#paint50_linear_935_10)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.979 320.799C113.045 319.895 112.371 319.089 111.45 319.023C110.546 318.958 109.74 319.632 109.674 320.553C109.609 321.457 110.283 322.263 111.204 322.329C112.108 322.395 112.914 321.72 112.979 320.799Z",
    fill: "url(#paint51_linear_935_10)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M112.979 320.799C113.045 319.895 112.371 319.089 111.45 319.023C110.546 318.958 109.74 319.632 109.674 320.553C109.609 321.457 110.283 322.263 111.204 322.329C112.108 322.395 112.914 321.72 112.979 320.799Z",
    fill: "url(#paint52_linear_935_10)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M112.979 320.799C113.045 319.895 112.371 319.089 111.45 319.023C110.546 318.958 109.74 319.632 109.674 320.553C109.609 321.457 110.283 322.263 111.204 322.329C112.108 322.395 112.914 321.72 112.979 320.799Z",
    fill: "url(#paint53_linear_935_10)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M114.048 306.674C114.114 305.769 113.44 304.963 112.519 304.898C111.615 304.832 110.809 305.506 110.743 306.427C110.677 307.331 111.352 308.137 112.272 308.203C113.177 308.269 113.982 307.595 114.048 306.674Z",
    fill: "url(#paint54_linear_935_10)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.048 306.674C114.114 305.769 113.44 304.963 112.519 304.898C111.615 304.832 110.809 305.506 110.743 306.427C110.677 307.331 111.352 308.137 112.272 308.203C113.177 308.269 113.982 307.595 114.048 306.674Z",
    fill: "url(#paint55_linear_935_10)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M114.048 306.674C114.114 305.769 113.44 304.963 112.519 304.898C111.615 304.832 110.809 305.506 110.743 306.427C110.677 307.331 111.352 308.137 112.272 308.203C113.177 308.269 113.982 307.595 114.048 306.674Z",
    fill: "url(#paint56_linear_935_10)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M115.117 292.548C115.183 291.643 114.509 290.838 113.588 290.772C112.684 290.706 111.878 291.38 111.812 292.301C111.746 293.206 112.42 294.011 113.341 294.077C114.246 294.143 115.051 293.469 115.117 292.548Z",
    fill: "url(#paint57_linear_935_10)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.117 292.548C115.183 291.643 114.509 290.838 113.588 290.772C112.684 290.706 111.878 291.38 111.812 292.301C111.746 293.206 112.42 294.011 113.341 294.077C114.246 294.143 115.051 293.469 115.117 292.548Z",
    fill: "url(#paint58_linear_935_10)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M115.117 292.548C115.183 291.643 114.509 290.838 113.588 290.772C112.684 290.706 111.878 291.38 111.812 292.301C111.746 293.206 112.42 294.011 113.341 294.077C114.246 294.143 115.051 293.469 115.117 292.548Z",
    fill: "url(#paint59_linear_935_10)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5201 383.486C96.4543 384.39 97.1284 385.196 98.0493 385.262C98.9536 385.328 99.7593 384.653 99.8251 383.733C99.8909 382.828 99.2167 382.022 98.2959 381.957C97.3751 381.891 96.5858 382.565 96.5201 383.486Z",
    fill: "url(#paint60_linear_935_10)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5201 383.486C96.4543 384.39 97.1284 385.196 98.0493 385.262C98.9536 385.328 99.7593 384.653 99.8251 383.733C99.8909 382.828 99.2167 382.022 98.2959 381.957C97.3751 381.891 96.5858 382.565 96.5201 383.486Z",
    fill: "url(#paint61_linear_935_10)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5201 383.486C96.4543 384.39 97.1284 385.196 98.0493 385.262C98.9536 385.328 99.7593 384.653 99.8251 383.733C99.8909 382.828 99.2167 382.022 98.2959 381.957C97.3751 381.891 96.5858 382.565 96.5201 383.486Z",
    fill: "url(#paint62_linear_935_10)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5889 369.36C97.5231 370.265 98.1973 371.07 99.1181 371.136C100.022 371.202 100.828 370.528 100.894 369.607C100.96 368.702 100.286 367.897 99.3647 367.831C98.4604 367.765 97.6547 368.439 97.5889 369.36Z",
    fill: "url(#paint63_linear_935_10)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5889 369.36C97.5231 370.265 98.1973 371.07 99.1181 371.136C100.022 371.202 100.828 370.528 100.894 369.607C100.96 368.702 100.286 367.897 99.3647 367.831C98.4604 367.765 97.6547 368.439 97.5889 369.36Z",
    fill: "url(#paint64_linear_935_10)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5889 369.36C97.5231 370.265 98.1973 371.07 99.1181 371.136C100.022 371.202 100.828 370.528 100.894 369.607C100.96 368.702 100.286 367.897 99.3647 367.831C98.4604 367.765 97.6547 368.439 97.5889 369.36Z",
    fill: "url(#paint65_linear_935_10)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6577 355.234C98.592 356.139 99.2661 356.945 100.187 357.01C101.091 357.076 101.897 356.402 101.963 355.481C102.029 354.576 101.354 353.771 100.434 353.705C99.5292 353.639 98.7235 354.313 98.6577 355.234Z",
    fill: "url(#paint66_linear_935_10)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6577 355.234C98.592 356.139 99.2661 356.945 100.187 357.01C101.091 357.076 101.897 356.402 101.963 355.481C102.029 354.576 101.354 353.771 100.434 353.705C99.5292 353.639 98.7235 354.313 98.6577 355.234Z",
    fill: "url(#paint67_linear_935_10)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6577 355.234C98.592 356.139 99.2661 356.945 100.187 357.01C101.091 357.076 101.897 356.402 101.963 355.481C102.029 354.576 101.354 353.771 100.434 353.705C99.5292 353.639 98.7235 354.313 98.6577 355.234Z",
    fill: "url(#paint68_linear_935_10)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7266 341.108C99.6608 342.013 100.335 342.819 101.256 342.884C102.16 342.95 102.966 342.276 103.032 341.355C103.097 340.451 102.423 339.645 101.502 339.579C100.598 339.513 99.7924 340.188 99.7266 341.108Z",
    fill: "url(#paint69_linear_935_10)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7266 341.108C99.6608 342.013 100.335 342.819 101.256 342.884C102.16 342.95 102.966 342.276 103.032 341.355C103.097 340.451 102.423 339.645 101.502 339.579C100.598 339.513 99.7924 340.188 99.7266 341.108Z",
    fill: "url(#paint70_linear_935_10)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7266 341.108C99.6608 342.013 100.335 342.819 101.256 342.884C102.16 342.95 102.966 342.276 103.032 341.355C103.097 340.451 102.423 339.645 101.502 339.579C100.598 339.513 99.7924 340.188 99.7266 341.108Z",
    fill: "url(#paint71_linear_935_10)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 327.229C104.166 326.325 103.492 325.519 102.571 325.453C101.65 325.388 100.861 326.062 100.795 326.983C100.73 327.904 101.404 328.693 102.325 328.759C103.229 328.824 104.035 328.15 104.1 327.229Z",
    fill: "url(#paint72_linear_935_10)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 327.229C104.166 326.325 103.492 325.519 102.571 325.453C101.65 325.388 100.861 326.062 100.795 326.983C100.73 327.904 101.404 328.693 102.325 328.759C103.229 328.824 104.035 328.15 104.1 327.229Z",
    fill: "url(#paint73_linear_935_10)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 327.229C104.166 326.325 103.492 325.519 102.571 325.453C101.65 325.388 100.861 326.062 100.795 326.983C100.73 327.904 101.404 328.693 102.325 328.759C103.229 328.824 104.035 328.15 104.1 327.229Z",
    fill: "url(#paint74_linear_935_10)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M105.169 313.103C105.235 312.199 104.561 311.393 103.64 311.327C102.736 311.262 101.93 311.936 101.864 312.857C101.799 313.778 102.473 314.567 103.393 314.633C104.298 314.699 105.104 314.024 105.169 313.103Z",
    fill: "url(#paint75_linear_935_10)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M105.169 313.103C105.235 312.199 104.561 311.393 103.64 311.327C102.736 311.262 101.93 311.936 101.864 312.857C101.799 313.778 102.473 314.567 103.393 314.633C104.298 314.699 105.104 314.024 105.169 313.103Z",
    fill: "url(#paint76_linear_935_10)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M105.169 313.103C105.235 312.199 104.561 311.393 103.64 311.327C102.736 311.262 101.93 311.936 101.864 312.857C101.799 313.778 102.473 314.567 103.393 314.633C104.298 314.699 105.104 314.024 105.169 313.103Z",
    fill: "url(#paint77_linear_935_10)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M106.238 298.978C106.304 298.073 105.63 297.267 104.709 297.202C103.805 297.136 102.999 297.81 102.933 298.731C102.867 299.635 103.542 300.441 104.462 300.507C105.367 300.573 106.172 299.898 106.238 298.978Z",
    fill: "url(#paint78_linear_935_10)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.238 298.978C106.304 298.073 105.63 297.267 104.709 297.202C103.805 297.136 102.999 297.81 102.933 298.731C102.867 299.635 103.542 300.441 104.462 300.507C105.367 300.573 106.172 299.898 106.238 298.978Z",
    fill: "url(#paint79_linear_935_10)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M106.238 298.978C106.304 298.073 105.63 297.267 104.709 297.202C103.805 297.136 102.999 297.81 102.933 298.731C102.867 299.635 103.542 300.441 104.462 300.507C105.367 300.573 106.172 299.898 106.238 298.978Z",
    fill: "url(#paint80_linear_935_10)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107.307 284.852C107.373 283.947 106.699 283.141 105.778 283.076C104.857 283.01 104.068 283.684 104.002 284.605C103.936 285.51 104.61 286.315 105.531 286.381C106.436 286.447 107.241 285.773 107.307 284.852Z",
    fill: "url(#paint81_linear_935_10)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M107.307 284.852C107.373 283.947 106.699 283.141 105.778 283.076C104.857 283.01 104.068 283.684 104.002 284.605C103.936 285.51 104.61 286.315 105.531 286.381C106.436 286.447 107.241 285.773 107.307 284.852Z",
    fill: "url(#paint82_linear_935_10)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M107.307 284.852C107.373 283.947 106.699 283.141 105.778 283.076C104.857 283.01 104.068 283.684 104.002 284.605C103.936 285.51 104.61 286.315 105.531 286.381C106.436 286.447 107.241 285.773 107.307 284.852Z",
    fill: "url(#paint83_linear_935_10)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6739 389.916C87.6081 390.82 88.2823 391.626 89.2031 391.692C90.1074 391.758 90.9131 391.083 90.9789 390.162C91.0447 389.242 90.3705 388.452 89.4497 388.386C88.5453 388.321 87.7396 388.995 87.6739 389.916Z",
    fill: "url(#paint84_linear_935_10)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6739 389.916C87.6081 390.82 88.2823 391.626 89.2031 391.692C90.1074 391.758 90.9131 391.083 90.9789 390.162C91.0447 389.242 90.3705 388.452 89.4497 388.386C88.5453 388.321 87.7396 388.995 87.6739 389.916Z",
    fill: "url(#paint85_linear_935_10)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6739 389.916C87.6081 390.82 88.2823 391.626 89.2031 391.692C90.1074 391.758 90.9131 391.083 90.9789 390.162C91.0447 389.242 90.3705 388.452 89.4497 388.386C88.5453 388.321 87.7396 388.995 87.6739 389.916Z",
    fill: "url(#paint86_linear_935_10)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7427 375.79C88.6769 376.694 89.3511 377.5 90.2719 377.566C91.1763 377.632 91.982 376.957 92.0477 376.037C92.1135 375.132 91.4394 374.326 90.5185 374.261C89.6142 374.195 88.8085 374.869 88.7427 375.79Z",
    fill: "url(#paint87_linear_935_10)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7427 375.79C88.6769 376.694 89.3511 377.5 90.2719 377.566C91.1763 377.632 91.982 376.957 92.0477 376.037C92.1135 375.132 91.4394 374.326 90.5185 374.261C89.6142 374.195 88.8085 374.869 88.7427 375.79Z",
    fill: "url(#paint88_linear_935_10)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7427 375.79C88.6769 376.694 89.3511 377.5 90.2719 377.566C91.1763 377.632 91.982 376.957 92.0477 376.037C92.1135 375.132 91.4394 374.326 90.5185 374.261C89.6142 374.195 88.8085 374.869 88.7427 375.79Z",
    fill: "url(#paint89_linear_935_10)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8116 361.664C89.7458 362.569 90.4199 363.374 91.3408 363.44C92.2451 363.506 93.0508 362.832 93.1166 361.911C93.1824 361.006 92.5082 360.201 91.5874 360.135C90.683 360.069 89.8773 360.743 89.8116 361.664Z",
    fill: "url(#paint90_linear_935_10)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8116 361.664C89.7458 362.569 90.4199 363.374 91.3408 363.44C92.2451 363.506 93.0508 362.832 93.1166 361.911C93.1824 361.006 92.5082 360.201 91.5874 360.135C90.683 360.069 89.8773 360.743 89.8116 361.664Z",
    fill: "url(#paint91_linear_935_10)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8116 361.664C89.7458 362.569 90.4199 363.374 91.3408 363.44C92.2451 363.506 93.0508 362.832 93.1166 361.911C93.1824 361.006 92.5082 360.201 91.5874 360.135C90.683 360.069 89.8773 360.743 89.8116 361.664Z",
    fill: "url(#paint92_linear_935_10)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8804 347.538C90.8146 348.443 91.4888 349.248 92.4096 349.314C93.314 349.38 94.1197 348.706 94.1854 347.785C94.2512 346.88 93.577 346.075 92.6562 346.009C91.7519 345.943 90.9462 346.617 90.8804 347.538Z",
    fill: "url(#paint93_linear_935_10)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8804 347.538C90.8146 348.443 91.4888 349.248 92.4096 349.314C93.314 349.38 94.1197 348.706 94.1854 347.785C94.2512 346.88 93.577 346.075 92.6562 346.009C91.7519 345.943 90.9462 346.617 90.8804 347.538Z",
    fill: "url(#paint94_linear_935_10)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8804 347.538C90.8146 348.443 91.4888 349.248 92.4096 349.314C93.314 349.38 94.1197 348.706 94.1854 347.785C94.2512 346.88 93.577 346.075 92.6562 346.009C91.7519 345.943 90.9462 346.617 90.8804 347.538Z",
    fill: "url(#paint95_linear_935_10)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9493 333.412C91.8835 334.317 92.5576 335.123 93.4784 335.188C94.3828 335.254 95.1885 334.58 95.2543 333.659C95.3201 332.755 94.6459 331.949 93.7251 331.883C92.8207 331.817 92.015 332.492 91.9493 333.412Z",
    fill: "url(#paint96_linear_935_10)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9493 333.412C91.8835 334.317 92.5576 335.123 93.4784 335.188C94.3828 335.254 95.1885 334.58 95.2543 333.659C95.3201 332.755 94.6459 331.949 93.7251 331.883C92.8207 331.817 92.015 332.492 91.9493 333.412Z",
    fill: "url(#paint97_linear_935_10)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9493 333.412C91.8835 334.317 92.5576 335.123 93.4784 335.188C94.3828 335.254 95.1885 334.58 95.2543 333.659C95.3201 332.755 94.6459 331.949 93.7251 331.883C92.8207 331.817 92.015 332.492 91.9493 333.412Z",
    fill: "url(#paint98_linear_935_10)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3227 319.533C96.3884 318.629 95.7143 317.823 94.7935 317.757C93.8891 317.691 93.0834 318.366 93.0176 319.287C92.9518 320.191 93.626 320.997 94.5468 321.063C95.4512 321.128 96.2569 320.454 96.3227 319.533Z",
    fill: "url(#paint99_linear_935_10)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3227 319.533C96.3884 318.629 95.7143 317.823 94.7935 317.757C93.8891 317.691 93.0834 318.366 93.0176 319.287C92.9518 320.191 93.626 320.997 94.5468 321.063C95.4512 321.128 96.2569 320.454 96.3227 319.533Z",
    fill: "url(#paint100_linear_935_10)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3227 319.533C96.3884 318.629 95.7143 317.823 94.7935 317.757C93.8891 317.691 93.0834 318.366 93.0176 319.287C92.9518 320.191 93.626 320.997 94.5468 321.063C95.4512 321.128 96.2569 320.454 96.3227 319.533Z",
    fill: "url(#paint101_linear_935_10)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3915 305.407C97.4573 304.503 96.7831 303.697 95.8623 303.631C94.9579 303.566 94.1522 304.24 94.0865 305.161C94.0207 306.065 94.6949 306.871 95.6157 306.937C96.52 307.002 97.3257 306.328 97.3915 305.407Z",
    fill: "url(#paint102_linear_935_10)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3915 305.407C97.4573 304.503 96.7831 303.697 95.8623 303.631C94.9579 303.566 94.1522 304.24 94.0865 305.161C94.0207 306.065 94.6949 306.871 95.6157 306.937C96.52 307.002 97.3257 306.328 97.3915 305.407Z",
    fill: "url(#paint103_linear_935_10)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3915 305.407C97.4573 304.503 96.7831 303.697 95.8623 303.631C94.9579 303.566 94.1522 304.24 94.0865 305.161C94.0207 306.065 94.6949 306.871 95.6157 306.937C96.52 307.002 97.3257 306.328 97.3915 305.407Z",
    fill: "url(#paint104_linear_935_10)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4603 291.282C98.5261 290.377 97.852 289.571 96.9312 289.506C96.0268 289.44 95.2211 290.114 95.1553 291.035C95.0895 291.939 95.7637 292.745 96.6845 292.811C97.5889 292.877 98.3946 292.202 98.4603 291.282Z",
    fill: "url(#paint105_linear_935_10)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4603 291.282C98.5261 290.377 97.852 289.571 96.9312 289.506C96.0268 289.44 95.2211 290.114 95.1553 291.035C95.0895 291.939 95.7637 292.745 96.6845 292.811C97.5889 292.877 98.3946 292.202 98.4603 291.282Z",
    fill: "url(#paint106_linear_935_10)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4603 291.282C98.5261 290.377 97.852 289.571 96.9312 289.506C96.0268 289.44 95.2211 290.114 95.1553 291.035C95.0895 291.939 95.7637 292.745 96.6845 292.811C97.5889 292.877 98.3946 292.202 98.4603 291.282Z",
    fill: "url(#paint107_linear_935_10)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5707 394.816C79.7486 394.75 79.0251 395.293 78.8442 396.066C79.8308 395.902 80.8174 395.721 81.804 395.507C81.5244 395.112 81.0969 394.849 80.5872 394.8L80.5707 394.816Z",
    fill: "url(#paint108_linear_935_10)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5707 394.816C79.7486 394.75 79.0251 395.293 78.8442 396.066C79.8308 395.902 80.8174 395.721 81.804 395.507C81.5244 395.112 81.0969 394.849 80.5872 394.8L80.5707 394.816Z",
    fill: "url(#paint109_linear_935_10)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5707 394.816C79.7486 394.75 79.0251 395.293 78.8442 396.066C79.8308 395.902 80.8174 395.721 81.804 395.507C81.5244 395.112 81.0969 394.849 80.5872 394.8L80.5707 394.816Z",
    fill: "url(#paint110_linear_935_10)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8633 382.22C79.7975 383.124 80.4717 383.93 81.3925 383.996C82.2969 384.061 83.1026 383.387 83.1684 382.466C83.2341 381.562 82.56 380.756 81.6392 380.69C80.7348 380.625 79.9291 381.299 79.8633 382.22Z",
    fill: "url(#paint111_linear_935_10)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8633 382.22C79.7975 383.124 80.4717 383.93 81.3925 383.996C82.2969 384.061 83.1026 383.387 83.1684 382.466C83.2341 381.562 82.56 380.756 81.6392 380.69C80.7348 380.625 79.9291 381.299 79.8633 382.22Z",
    fill: "url(#paint112_linear_935_10)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8633 382.22C79.7975 383.124 80.4717 383.93 81.3925 383.996C82.2969 384.061 83.1026 383.387 83.1684 382.466C83.2341 381.562 82.56 380.756 81.6392 380.69C80.7348 380.625 79.9291 381.299 79.8633 382.22Z",
    fill: "url(#paint113_linear_935_10)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9322 368.094C80.8664 368.998 81.5406 369.804 82.4614 369.87C83.3657 369.936 84.1714 369.261 84.2372 368.341C84.303 367.436 83.6288 366.63 82.708 366.565C81.8036 366.499 80.9979 367.173 80.9322 368.094Z",
    fill: "url(#paint114_linear_935_10)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9322 368.094C80.8664 368.998 81.5406 369.804 82.4614 369.87C83.3657 369.936 84.1714 369.261 84.2372 368.341C84.303 367.436 83.6288 366.63 82.708 366.565C81.8036 366.499 80.9979 367.173 80.9322 368.094Z",
    fill: "url(#paint115_linear_935_10)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9322 368.094C80.8664 368.998 81.5406 369.804 82.4614 369.87C83.3657 369.936 84.1714 369.261 84.2372 368.341C84.303 367.436 83.6288 366.63 82.708 366.565C81.8036 366.499 80.9979 367.173 80.9322 368.094Z",
    fill: "url(#paint116_linear_935_10)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M82.001 353.968C81.9352 354.872 82.6094 355.678 83.5302 355.744C84.4346 355.81 85.2403 355.136 85.3061 354.215C85.3718 353.31 84.6977 352.504 83.7769 352.439C82.8725 352.373 82.0668 353.047 82.001 353.968Z",
    fill: "url(#paint117_linear_935_10)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M82.001 353.968C81.9352 354.872 82.6094 355.678 83.5302 355.744C84.4346 355.81 85.2403 355.136 85.3061 354.215C85.3718 353.31 84.6977 352.504 83.7769 352.439C82.8725 352.373 82.0668 353.047 82.001 353.968Z",
    fill: "url(#paint118_linear_935_10)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M82.001 353.968C81.9352 354.872 82.6094 355.678 83.5302 355.744C84.4346 355.81 85.2403 355.136 85.3061 354.215C85.3718 353.31 84.6977 352.504 83.7769 352.439C82.8725 352.373 82.0668 353.047 82.001 353.968Z",
    fill: "url(#paint119_linear_935_10)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0699 339.842C83.0041 340.747 83.6782 341.552 84.5991 341.618C85.5199 341.684 86.3091 341.01 86.3749 340.089C86.4407 339.184 85.7665 338.379 84.8457 338.313C83.9413 338.247 83.1356 338.921 83.0699 339.842Z",
    fill: "url(#paint120_linear_935_10)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0699 339.842C83.0041 340.747 83.6782 341.552 84.5991 341.618C85.5199 341.684 86.3091 341.01 86.3749 340.089C86.4407 339.184 85.7665 338.379 84.8457 338.313C83.9413 338.247 83.1356 338.921 83.0699 339.842Z",
    fill: "url(#paint121_linear_935_10)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0699 339.842C83.0041 340.747 83.6782 341.552 84.5991 341.618C85.5199 341.684 86.3091 341.01 86.3749 340.089C86.4407 339.184 85.7665 338.379 84.8457 338.313C83.9413 338.247 83.1356 338.921 83.0699 339.842Z",
    fill: "url(#paint122_linear_935_10)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4437 325.963C87.5095 325.059 86.8354 324.253 85.9145 324.187C85.0102 324.121 84.2045 324.796 84.1387 325.716C84.0729 326.621 84.7471 327.427 85.6679 327.492C86.5723 327.558 87.378 326.884 87.4437 325.963Z",
    fill: "url(#paint123_linear_935_10)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4437 325.963C87.5095 325.059 86.8354 324.253 85.9145 324.187C85.0102 324.121 84.2045 324.796 84.1387 325.716C84.0729 326.621 84.7471 327.427 85.6679 327.492C86.5723 327.558 87.378 326.884 87.4437 325.963Z",
    fill: "url(#paint124_linear_935_10)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4437 325.963C87.5095 325.059 86.8354 324.253 85.9145 324.187C85.0102 324.121 84.2045 324.796 84.1387 325.716C84.0729 326.621 84.7471 327.427 85.6679 327.492C86.5723 327.558 87.378 326.884 87.4437 325.963Z",
    fill: "url(#paint125_linear_935_10)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5126 311.837C88.5784 310.933 87.9042 310.127 86.9834 310.061C86.079 309.995 85.2733 310.67 85.2076 311.591C85.1418 312.495 85.8159 313.301 86.7368 313.367C87.6411 313.432 88.4468 312.758 88.5126 311.837Z",
    fill: "url(#paint126_linear_935_10)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5126 311.837C88.5784 310.933 87.9042 310.127 86.9834 310.061C86.079 309.995 85.2733 310.67 85.2076 311.591C85.1418 312.495 85.8159 313.301 86.7368 313.367C87.6411 313.432 88.4468 312.758 88.5126 311.837Z",
    fill: "url(#paint127_linear_935_10)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5126 311.837C88.5784 310.933 87.9042 310.127 86.9834 310.061C86.079 309.995 85.2733 310.67 85.2076 311.591C85.1418 312.495 85.8159 313.301 86.7368 313.367C87.6411 313.432 88.4468 312.758 88.5126 311.837Z",
    fill: "url(#paint128_linear_935_10)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5814 297.711C89.6472 296.807 88.973 296.001 88.0522 295.935C87.1479 295.87 86.3422 296.544 86.2764 297.465C86.2106 298.369 86.8848 299.175 87.8056 299.241C88.71 299.306 89.5157 298.632 89.5814 297.711Z",
    fill: "url(#paint129_linear_935_10)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5814 297.711C89.6472 296.807 88.973 296.001 88.0522 295.935C87.1479 295.87 86.3422 296.544 86.2764 297.465C86.2106 298.369 86.8848 299.175 87.8056 299.241C88.71 299.306 89.5157 298.632 89.5814 297.711Z",
    fill: "url(#paint130_linear_935_10)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5814 297.711C89.6472 296.807 88.973 296.001 88.0522 295.935C87.1479 295.87 86.3422 296.544 86.2764 297.465C86.2106 298.369 86.8848 299.175 87.8056 299.241C88.71 299.306 89.5157 298.632 89.5814 297.711Z",
    fill: "url(#paint131_linear_935_10)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6503 283.585C90.7161 282.681 90.0419 281.875 89.1211 281.809C88.2167 281.744 87.411 282.418 87.3452 283.339C87.2795 284.243 87.9536 285.049 88.8744 285.115C89.7788 285.181 90.5845 284.506 90.6503 283.585Z",
    fill: "url(#paint132_linear_935_10)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6503 283.585C90.7161 282.681 90.0419 281.875 89.1211 281.809C88.2167 281.744 87.411 282.418 87.3452 283.339C87.2795 284.243 87.9536 285.049 88.8744 285.115C89.7788 285.181 90.5845 284.506 90.6503 283.585Z",
    fill: "url(#paint133_linear_935_10)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6503 283.585C90.7161 282.681 90.0419 281.875 89.1211 281.809C88.2167 281.744 87.411 282.418 87.3452 283.339C87.2795 284.243 87.9536 285.049 88.8744 285.115C89.7788 285.181 90.5845 284.506 90.6503 283.585Z",
    fill: "url(#paint134_linear_935_10)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0171 388.649C70.9514 389.554 71.6255 390.36 72.5463 390.425C73.4507 390.491 74.2564 389.817 74.3222 388.896C74.3879 387.992 73.7138 387.186 72.793 387.12C71.8886 387.054 71.0829 387.729 71.0171 388.649Z",
    fill: "url(#paint135_linear_935_10)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0171 388.649C70.9514 389.554 71.6255 390.36 72.5463 390.425C73.4507 390.491 74.2564 389.817 74.3222 388.896C74.3879 387.992 73.7138 387.186 72.793 387.12C71.8886 387.054 71.0829 387.729 71.0171 388.649Z",
    fill: "url(#paint136_linear_935_10)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0171 388.649C70.9514 389.554 71.6255 390.36 72.5463 390.425C73.4507 390.491 74.2564 389.817 74.3222 388.896C74.3879 387.992 73.7138 387.186 72.793 387.12C71.8886 387.054 71.0829 387.729 71.0171 388.649Z",
    fill: "url(#paint137_linear_935_10)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M72.086 374.524C72.0202 375.428 72.6944 376.234 73.6152 376.3C74.5195 376.365 75.3252 375.691 75.391 374.77C75.4568 373.866 74.7826 373.06 73.8618 372.994C72.9574 372.929 72.1517 373.603 72.086 374.524Z",
    fill: "url(#paint138_linear_935_10)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M72.086 374.524C72.0202 375.428 72.6944 376.234 73.6152 376.3C74.5195 376.365 75.3252 375.691 75.391 374.77C75.4568 373.866 74.7826 373.06 73.8618 372.994C72.9574 372.929 72.1517 373.603 72.086 374.524Z",
    fill: "url(#paint139_linear_935_10)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M72.086 374.524C72.0202 375.428 72.6944 376.234 73.6152 376.3C74.5195 376.365 75.3252 375.691 75.391 374.77C75.4568 373.866 74.7826 373.06 73.8618 372.994C72.9574 372.929 72.1517 373.603 72.086 374.524Z",
    fill: "url(#paint140_linear_935_10)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1548 360.398C73.089 361.302 73.7632 362.108 74.684 362.174C75.5884 362.24 76.3941 361.565 76.4599 360.645C76.5256 359.74 75.8515 358.934 74.9307 358.869C74.0263 358.803 73.2206 359.477 73.1548 360.398Z",
    fill: "url(#paint141_linear_935_10)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1548 360.398C73.089 361.302 73.7632 362.108 74.684 362.174C75.5884 362.24 76.3941 361.565 76.4599 360.645C76.5256 359.74 75.8515 358.934 74.9307 358.869C74.0263 358.803 73.2206 359.477 73.1548 360.398Z",
    fill: "url(#paint142_linear_935_10)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1548 360.398C73.089 361.302 73.7632 362.108 74.684 362.174C75.5884 362.24 76.3941 361.565 76.4599 360.645C76.5256 359.74 75.8515 358.934 74.9307 358.869C74.0263 358.803 73.2206 359.477 73.1548 360.398Z",
    fill: "url(#paint143_linear_935_10)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2237 346.272C74.1579 347.176 74.8321 347.982 75.7529 348.048C76.6572 348.114 77.4629 347.44 77.5287 346.519C77.5945 345.614 76.9203 344.808 75.9995 344.743C75.0951 344.677 74.2894 345.351 74.2237 346.272Z",
    fill: "url(#paint144_linear_935_10)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2237 346.272C74.1579 347.176 74.8321 347.982 75.7529 348.048C76.6572 348.114 77.4629 347.44 77.5287 346.519C77.5945 345.614 76.9203 344.808 75.9995 344.743C75.0951 344.677 74.2894 345.351 74.2237 346.272Z",
    fill: "url(#paint145_linear_935_10)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2237 346.272C74.1579 347.176 74.8321 347.982 75.7529 348.048C76.6572 348.114 77.4629 347.44 77.5287 346.519C77.5945 345.614 76.9203 344.808 75.9995 344.743C75.0951 344.677 74.2894 345.351 74.2237 346.272Z",
    fill: "url(#paint146_linear_935_10)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2925 332.146C75.2267 333.051 75.9009 333.856 76.8217 333.922C77.7261 333.988 78.5318 333.314 78.5975 332.393C78.6633 331.488 77.9892 330.683 77.0684 330.617C76.164 330.551 75.3583 331.225 75.2925 332.146Z",
    fill: "url(#paint147_linear_935_10)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2925 332.146C75.2267 333.051 75.9009 333.856 76.8217 333.922C77.7261 333.988 78.5318 333.314 78.5975 332.393C78.6633 331.488 77.9892 330.683 77.0684 330.617C76.164 330.551 75.3583 331.225 75.2925 332.146Z",
    fill: "url(#paint148_linear_935_10)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2925 332.146C75.2267 333.051 75.9009 333.856 76.8217 333.922C77.7261 333.988 78.5318 333.314 78.5975 332.393C78.6633 331.488 77.9892 330.683 77.0684 330.617C76.164 330.551 75.3583 331.225 75.2925 332.146Z",
    fill: "url(#paint149_linear_935_10)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6664 318.267C79.7322 317.363 79.058 316.557 78.1372 316.491C77.2328 316.425 76.4271 317.099 76.3614 318.02C76.2956 318.925 76.9698 319.731 77.8906 319.796C78.7949 319.862 79.6006 319.188 79.6664 318.267Z",
    fill: "url(#paint150_linear_935_10)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6664 318.267C79.7322 317.363 79.058 316.557 78.1372 316.491C77.2328 316.425 76.4271 317.099 76.3614 318.02C76.2956 318.925 76.9698 319.731 77.8906 319.796C78.7949 319.862 79.6006 319.188 79.6664 318.267Z",
    fill: "url(#paint151_linear_935_10)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6664 318.267C79.7322 317.363 79.058 316.557 78.1372 316.491C77.2328 316.425 76.4271 317.099 76.3614 318.02C76.2956 318.925 76.9698 319.731 77.8906 319.796C78.7949 319.862 79.6006 319.188 79.6664 318.267Z",
    fill: "url(#paint152_linear_935_10)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7348 304.141C80.8005 303.237 80.1264 302.431 79.2056 302.365C78.3012 302.299 77.4955 302.974 77.4297 303.894C77.364 304.799 78.0381 305.605 78.9589 305.671C79.8633 305.736 80.669 305.062 80.7348 304.141Z",
    fill: "url(#paint153_linear_935_10)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7348 304.141C80.8005 303.237 80.1264 302.431 79.2056 302.365C78.3012 302.299 77.4955 302.974 77.4297 303.894C77.364 304.799 78.0381 305.605 78.9589 305.671C79.8633 305.736 80.669 305.062 80.7348 304.141Z",
    fill: "url(#paint154_linear_935_10)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7348 304.141C80.8005 303.237 80.1264 302.431 79.2056 302.365C78.3012 302.299 77.4955 302.974 77.4297 303.894C77.364 304.799 78.0381 305.605 78.9589 305.671C79.8633 305.736 80.669 305.062 80.7348 304.141Z",
    fill: "url(#paint155_linear_935_10)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8036 290.015C81.8694 289.111 81.1952 288.305 80.2744 288.239C79.37 288.174 78.5643 288.848 78.4986 289.769C78.4328 290.673 79.107 291.479 80.0278 291.545C80.9321 291.61 81.7378 290.936 81.8036 290.015Z",
    fill: "url(#paint156_linear_935_10)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8036 290.015C81.8694 289.111 81.1952 288.305 80.2744 288.239C79.37 288.174 78.5643 288.848 78.4986 289.769C78.4328 290.673 79.107 291.479 80.0278 291.545C80.9321 291.61 81.7378 290.936 81.8036 290.015Z",
    fill: "url(#paint157_linear_935_10)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8036 290.015C81.8694 289.111 81.1952 288.305 80.2744 288.239C79.37 288.174 78.5643 288.848 78.4986 289.769C78.4328 290.673 79.107 291.479 80.0278 291.545C80.9321 291.61 81.7378 290.936 81.8036 290.015Z",
    fill: "url(#paint158_linear_935_10)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4431 395.342C65.5089 394.438 64.8347 393.632 63.9139 393.566C63.0095 393.501 62.2038 394.175 62.138 395.096C62.0723 395.967 62.6971 396.724 63.5521 396.855C63.6344 396.855 63.733 396.855 63.8152 396.872C64.6703 396.872 65.3773 396.214 65.4431 395.342Z",
    fill: "url(#paint159_linear_935_10)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4431 395.342C65.5089 394.438 64.8347 393.632 63.9139 393.566C63.0095 393.501 62.2038 394.175 62.138 395.096C62.0723 395.967 62.6971 396.724 63.5521 396.855C63.6344 396.855 63.733 396.855 63.8152 396.872C64.6703 396.872 65.3773 396.214 65.4431 395.342Z",
    fill: "url(#paint160_linear_935_10)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4431 395.342C65.5089 394.438 64.8347 393.632 63.9139 393.566C63.0095 393.501 62.2038 394.175 62.138 395.096C62.0723 395.967 62.6971 396.724 63.5521 396.855C63.6344 396.855 63.733 396.855 63.8152 396.872C64.6703 396.872 65.3773 396.214 65.4431 395.342Z",
    fill: "url(#paint161_linear_935_10)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2066 380.953C63.1408 381.858 63.815 382.664 64.7358 382.729C65.6401 382.795 66.4458 382.121 66.5116 381.2C66.5774 380.296 65.9032 379.49 64.9824 379.424C64.0781 379.358 63.2723 380.033 63.2066 380.953Z",
    fill: "url(#paint162_linear_935_10)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2066 380.953C63.1408 381.858 63.815 382.664 64.7358 382.729C65.6401 382.795 66.4458 382.121 66.5116 381.2C66.5774 380.296 65.9032 379.49 64.9824 379.424C64.0781 379.358 63.2723 380.033 63.2066 380.953Z",
    fill: "url(#paint163_linear_935_10)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2066 380.953C63.1408 381.858 63.815 382.664 64.7358 382.729C65.6401 382.795 66.4458 382.121 66.5116 381.2C66.5774 380.296 65.9032 379.49 64.9824 379.424C64.0781 379.358 63.2723 380.033 63.2066 380.953Z",
    fill: "url(#paint164_linear_935_10)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2754 366.828C64.2097 367.732 64.8838 368.538 65.8046 368.604C66.709 368.669 67.5147 367.995 67.5805 367.074C67.6462 366.17 66.9721 365.364 66.0513 365.298C65.1469 365.233 64.3412 365.907 64.2754 366.828Z",
    fill: "url(#paint165_linear_935_10)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2754 366.828C64.2097 367.732 64.8838 368.538 65.8046 368.604C66.709 368.669 67.5147 367.995 67.5805 367.074C67.6462 366.17 66.9721 365.364 66.0513 365.298C65.1469 365.233 64.3412 365.907 64.2754 366.828Z",
    fill: "url(#paint166_linear_935_10)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2754 366.828C64.2097 367.732 64.8838 368.538 65.8046 368.604C66.709 368.669 67.5147 367.995 67.5805 367.074C67.6462 366.17 66.9721 365.364 66.0513 365.298C65.1469 365.233 64.3412 365.907 64.2754 366.828Z",
    fill: "url(#paint167_linear_935_10)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3443 352.702C65.2785 353.606 65.9527 354.412 66.8735 354.478C67.7943 354.544 68.5835 353.869 68.6493 352.948C68.7151 352.044 68.0409 351.238 67.1201 351.172C66.2157 351.107 65.41 351.781 65.3443 352.702Z",
    fill: "url(#paint168_linear_935_10)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3443 352.702C65.2785 353.606 65.9527 354.412 66.8735 354.478C67.7943 354.544 68.5835 353.869 68.6493 352.948C68.7151 352.044 68.0409 351.238 67.1201 351.172C66.2157 351.107 65.41 351.781 65.3443 352.702Z",
    fill: "url(#paint169_linear_935_10)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3443 352.702C65.2785 353.606 65.9527 354.412 66.8735 354.478C67.7943 354.544 68.5835 353.869 68.6493 352.948C68.7151 352.044 68.0409 351.238 67.1201 351.172C66.2157 351.107 65.41 351.781 65.3443 352.702Z",
    fill: "url(#paint170_linear_935_10)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4131 338.576C66.3473 339.48 67.0215 340.286 67.9423 340.352C68.8467 340.418 69.6524 339.744 69.7182 338.823C69.7839 337.918 69.1098 337.112 68.189 337.047C67.2682 336.981 66.4789 337.655 66.4131 338.576Z",
    fill: "url(#paint171_linear_935_10)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4131 338.576C66.3473 339.48 67.0215 340.286 67.9423 340.352C68.8467 340.418 69.6524 339.744 69.7182 338.823C69.7839 337.918 69.1098 337.112 68.189 337.047C67.2682 336.981 66.4789 337.655 66.4131 338.576Z",
    fill: "url(#paint172_linear_935_10)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4131 338.576C66.3473 339.48 67.0215 340.286 67.9423 340.352C68.8467 340.418 69.6524 339.744 69.7182 338.823C69.7839 337.918 69.1098 337.112 68.189 337.047C67.2682 336.981 66.4789 337.655 66.4131 338.576Z",
    fill: "url(#paint173_linear_935_10)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M70.787 324.697C70.8528 323.792 70.1786 322.987 69.2578 322.921C68.3534 322.855 67.5477 323.529 67.482 324.45C67.4162 325.355 68.0904 326.16 69.0112 326.226C69.932 326.292 70.7212 325.618 70.787 324.697Z",
    fill: "url(#paint174_linear_935_10)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M70.787 324.697C70.8528 323.792 70.1786 322.987 69.2578 322.921C68.3534 322.855 67.5477 323.529 67.482 324.45C67.4162 325.355 68.0904 326.16 69.0112 326.226C69.932 326.292 70.7212 325.618 70.787 324.697Z",
    fill: "url(#paint175_linear_935_10)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M70.787 324.697C70.8528 323.792 70.1786 322.987 69.2578 322.921C68.3534 322.855 67.5477 323.529 67.482 324.45C67.4162 325.355 68.0904 326.16 69.0112 326.226C69.932 326.292 70.7212 325.618 70.787 324.697Z",
    fill: "url(#paint176_linear_935_10)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8559 310.571C71.9216 309.667 71.2475 308.861 70.3267 308.795C69.4223 308.729 68.6166 309.403 68.5508 310.324C68.485 311.229 69.1592 312.035 70.08 312.1C70.9844 312.166 71.7901 311.492 71.8559 310.571Z",
    fill: "url(#paint177_linear_935_10)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8559 310.571C71.9216 309.667 71.2475 308.861 70.3267 308.795C69.4223 308.729 68.6166 309.403 68.5508 310.324C68.485 311.229 69.1592 312.035 70.08 312.1C70.9844 312.166 71.7901 311.492 71.8559 310.571Z",
    fill: "url(#paint178_linear_935_10)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8559 310.571C71.9216 309.667 71.2475 308.861 70.3267 308.795C69.4223 308.729 68.6166 309.403 68.5508 310.324C68.485 311.229 69.1592 312.035 70.08 312.1C70.9844 312.166 71.7901 311.492 71.8559 310.571Z",
    fill: "url(#paint179_linear_935_10)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9247 296.445C72.9905 295.541 72.3163 294.735 71.3955 294.669C70.4747 294.603 69.6854 295.278 69.6197 296.198C69.5539 297.103 70.2281 297.909 71.1489 297.974C72.0532 298.04 72.8589 297.366 72.9247 296.445Z",
    fill: "url(#paint180_linear_935_10)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9247 296.445C72.9905 295.541 72.3163 294.735 71.3955 294.669C70.4747 294.603 69.6854 295.278 69.6197 296.198C69.5539 297.103 70.2281 297.909 71.1489 297.974C72.0532 298.04 72.8589 297.366 72.9247 296.445Z",
    fill: "url(#paint181_linear_935_10)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9247 296.445C72.9905 295.541 72.3163 294.735 71.3955 294.669C70.4747 294.603 69.6854 295.278 69.6197 296.198C69.5539 297.103 70.2281 297.909 71.1489 297.974C72.0532 298.04 72.8589 297.366 72.9247 296.445Z",
    fill: "url(#paint182_linear_935_10)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9935 282.319C74.0593 281.415 73.3852 280.609 72.4643 280.543C71.56 280.478 70.7543 281.152 70.6885 282.073C70.6227 282.977 71.2969 283.783 72.2177 283.849C73.1221 283.914 73.9278 283.24 73.9935 282.319Z",
    fill: "url(#paint183_linear_935_10)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9935 282.319C74.0593 281.415 73.3852 280.609 72.4643 280.543C71.56 280.478 70.7543 281.152 70.6885 282.073C70.6227 282.977 71.2969 283.783 72.2177 283.849C73.1221 283.914 73.9278 283.24 73.9935 282.319Z",
    fill: "url(#paint184_linear_935_10)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9935 282.319C74.0593 281.415 73.3852 280.609 72.4643 280.543C71.56 280.478 70.7543 281.152 70.6885 282.073C70.6227 282.977 71.2969 283.783 72.2177 283.849C73.1221 283.914 73.9278 283.24 73.9935 282.319Z",
    fill: "url(#paint185_linear_935_10)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3604 387.4C54.2946 388.304 54.9688 389.11 55.8896 389.176C56.7939 389.242 57.5996 388.567 57.6654 387.646C57.7312 386.742 57.057 385.936 56.1362 385.87C55.2319 385.805 54.4262 386.479 54.3604 387.4Z",
    fill: "url(#paint186_linear_935_10)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3604 387.4C54.2946 388.304 54.9688 389.11 55.8896 389.176C56.7939 389.242 57.5996 388.567 57.6654 387.646C57.7312 386.742 57.057 385.936 56.1362 385.87C55.2319 385.805 54.4262 386.479 54.3604 387.4Z",
    fill: "url(#paint187_linear_935_10)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3604 387.4C54.2946 388.304 54.9688 389.11 55.8896 389.176C56.7939 389.242 57.5996 388.567 57.6654 387.646C57.7312 386.742 57.057 385.936 56.1362 385.87C55.2319 385.805 54.4262 386.479 54.3604 387.4Z",
    fill: "url(#paint188_linear_935_10)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4292 373.274C55.3635 374.178 56.0376 374.984 56.9584 375.05C57.8792 375.116 58.6685 374.441 58.7343 373.521C58.8 372.6 58.1259 371.81 57.2051 371.745C56.3007 371.679 55.495 372.353 55.4292 373.274Z",
    fill: "url(#paint189_linear_935_10)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4292 373.274C55.3635 374.178 56.0376 374.984 56.9584 375.05C57.8792 375.116 58.6685 374.441 58.7343 373.521C58.8 372.6 58.1259 371.81 57.2051 371.745C56.3007 371.679 55.495 372.353 55.4292 373.274Z",
    fill: "url(#paint190_linear_935_10)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4292 373.274C55.3635 374.178 56.0376 374.984 56.9584 375.05C57.8792 375.116 58.6685 374.441 58.7343 373.521C58.8 372.6 58.1259 371.81 57.2051 371.745C56.3007 371.679 55.495 372.353 55.4292 373.274Z",
    fill: "url(#paint191_linear_935_10)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4981 359.148C56.4323 360.052 57.1065 360.858 58.0273 360.924C58.9316 360.99 59.7373 360.316 59.8031 359.395C59.8689 358.49 59.1947 357.684 58.2739 357.619C57.3696 357.553 56.5639 358.227 56.4981 359.148Z",
    fill: "url(#paint192_linear_935_10)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4981 359.148C56.4323 360.052 57.1065 360.858 58.0273 360.924C58.9316 360.99 59.7373 360.316 59.8031 359.395C59.8689 358.49 59.1947 357.684 58.2739 357.619C57.3696 357.553 56.5639 358.227 56.4981 359.148Z",
    fill: "url(#paint193_linear_935_10)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4981 359.148C56.4323 360.052 57.1065 360.858 58.0273 360.924C58.9316 360.99 59.7373 360.316 59.8031 359.395C59.8689 358.49 59.1947 357.684 58.2739 357.619C57.3696 357.553 56.5639 358.227 56.4981 359.148Z",
    fill: "url(#paint194_linear_935_10)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5669 345.022C57.5012 345.927 58.1753 346.732 59.0961 346.798C60.0005 346.864 60.8062 346.19 60.872 345.269C60.9377 344.364 60.2636 343.559 59.3428 343.493C58.4384 343.427 57.6327 344.101 57.5669 345.022Z",
    fill: "url(#paint195_linear_935_10)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5669 345.022C57.5012 345.927 58.1753 346.732 59.0961 346.798C60.0005 346.864 60.8062 346.19 60.872 345.269C60.9377 344.364 60.2636 343.559 59.3428 343.493C58.4384 343.427 57.6327 344.101 57.5669 345.022Z",
    fill: "url(#paint196_linear_935_10)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5669 345.022C57.5012 345.927 58.1753 346.732 59.0961 346.798C60.0005 346.864 60.8062 346.19 60.872 345.269C60.9377 344.364 60.2636 343.559 59.3428 343.493C58.4384 343.427 57.6327 344.101 57.5669 345.022Z",
    fill: "url(#paint197_linear_935_10)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6358 330.896C58.57 331.801 59.2442 332.607 60.165 332.672C61.0693 332.738 61.875 332.064 61.9408 331.143C62.0066 330.239 61.3324 329.433 60.4116 329.367C59.5073 329.301 58.7015 329.975 58.6358 330.896Z",
    fill: "url(#paint198_linear_935_10)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6358 330.896C58.57 331.801 59.2442 332.607 60.165 332.672C61.0693 332.738 61.875 332.064 61.9408 331.143C62.0066 330.239 61.3324 329.433 60.4116 329.367C59.5073 329.301 58.7015 329.975 58.6358 330.896Z",
    fill: "url(#paint199_linear_935_10)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6358 330.896C58.57 331.801 59.2442 332.607 60.165 332.672C61.0693 332.738 61.875 332.064 61.9408 331.143C62.0066 330.239 61.3324 329.433 60.4116 329.367C59.5073 329.301 58.7015 329.975 58.6358 330.896Z",
    fill: "url(#paint200_linear_935_10)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0097 317.017C63.0754 316.113 62.4013 315.307 61.4805 315.241C60.5761 315.175 59.7704 315.85 59.7046 316.771C59.6389 317.675 60.313 318.481 61.2338 318.547C62.1382 318.612 62.9439 317.938 63.0097 317.017Z",
    fill: "url(#paint201_linear_935_10)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0097 317.017C63.0754 316.113 62.4013 315.307 61.4805 315.241C60.5761 315.175 59.7704 315.85 59.7046 316.771C59.6389 317.675 60.313 318.481 61.2338 318.547C62.1382 318.612 62.9439 317.938 63.0097 317.017Z",
    fill: "url(#paint202_linear_935_10)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0097 317.017C63.0754 316.113 62.4013 315.307 61.4805 315.241C60.5761 315.175 59.7704 315.85 59.7046 316.771C59.6389 317.675 60.313 318.481 61.2338 318.547C62.1382 318.612 62.9439 317.938 63.0097 317.017Z",
    fill: "url(#paint203_linear_935_10)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M64.078 302.891C64.1438 301.987 63.4696 301.181 62.5488 301.115C61.6445 301.05 60.8388 301.724 60.773 302.645C60.7072 303.549 61.3814 304.355 62.3022 304.421C63.2065 304.487 64.0123 303.812 64.078 302.891Z",
    fill: "url(#paint204_linear_935_10)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M64.078 302.891C64.1438 301.987 63.4696 301.181 62.5488 301.115C61.6445 301.05 60.8388 301.724 60.773 302.645C60.7072 303.549 61.3814 304.355 62.3022 304.421C63.2065 304.487 64.0123 303.812 64.078 302.891Z",
    fill: "url(#paint205_linear_935_10)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M64.078 302.891C64.1438 301.987 63.4696 301.181 62.5488 301.115C61.6445 301.05 60.8388 301.724 60.773 302.645C60.7072 303.549 61.3814 304.355 62.3022 304.421C63.2065 304.487 64.0123 303.812 64.078 302.891Z",
    fill: "url(#paint206_linear_935_10)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1469 288.766C65.2126 287.861 64.5385 287.055 63.6177 286.99C62.7133 286.924 61.9076 287.598 61.8418 288.519C61.7761 289.423 62.4502 290.229 63.371 290.295C64.2754 290.361 65.0811 289.686 65.1469 288.766Z",
    fill: "url(#paint207_linear_935_10)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1469 288.766C65.2126 287.861 64.5385 287.055 63.6177 286.99C62.7133 286.924 61.9076 287.598 61.8418 288.519C61.7761 289.423 62.4502 290.229 63.371 290.295C64.2754 290.361 65.0811 289.686 65.1469 288.766Z",
    fill: "url(#paint208_linear_935_10)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1469 288.766C65.2126 287.861 64.5385 287.055 63.6177 286.99C62.7133 286.924 61.9076 287.598 61.8418 288.519C61.7761 289.423 62.4502 290.229 63.371 290.295C64.2754 290.361 65.0811 289.686 65.1469 288.766Z",
    fill: "url(#paint209_linear_935_10)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2572 392.3C46.5338 392.251 45.9089 392.662 45.6294 393.287C46.6653 393.649 47.7012 393.977 48.7536 394.273C48.7536 394.208 48.7864 394.142 48.7864 394.076C48.8522 393.172 48.1781 392.366 47.2572 392.3Z",
    fill: "url(#paint210_linear_935_10)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2572 392.3C46.5338 392.251 45.9089 392.662 45.6294 393.287C46.6653 393.649 47.7012 393.977 48.7536 394.273C48.7536 394.208 48.7864 394.142 48.7864 394.076C48.8522 393.172 48.1781 392.366 47.2572 392.3Z",
    fill: "url(#paint211_linear_935_10)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2572 392.3C46.5338 392.251 45.9089 392.662 45.6294 393.287C46.6653 393.649 47.7012 393.977 48.7536 394.273C48.7536 394.208 48.7864 394.142 48.7864 394.076C48.8522 393.172 48.1781 392.366 47.2572 392.3Z",
    fill: "url(#paint212_linear_935_10)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5498 379.704C46.4841 380.608 47.1582 381.414 48.079 381.48C48.9834 381.545 49.7891 380.871 49.8549 379.95C49.9206 379.046 49.2465 378.24 48.3257 378.174C47.4213 378.109 46.6156 378.783 46.5498 379.704Z",
    fill: "url(#paint213_linear_935_10)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5498 379.704C46.4841 380.608 47.1582 381.414 48.079 381.48C48.9834 381.545 49.7891 380.871 49.8549 379.95C49.9206 379.046 49.2465 378.24 48.3257 378.174C47.4213 378.109 46.6156 378.783 46.5498 379.704Z",
    fill: "url(#paint214_linear_935_10)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5498 379.704C46.4841 380.608 47.1582 381.414 48.079 381.48C48.9834 381.545 49.7891 380.871 49.8549 379.95C49.9206 379.046 49.2465 378.24 48.3257 378.174C47.4213 378.109 46.6156 378.783 46.5498 379.704Z",
    fill: "url(#paint215_linear_935_10)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6187 365.578C47.5529 366.482 48.2271 367.288 49.1479 367.354C50.0522 367.42 50.858 366.745 50.9237 365.825C50.9895 364.92 50.3153 364.114 49.3945 364.048C48.4902 363.983 47.6845 364.657 47.6187 365.578Z",
    fill: "url(#paint216_linear_935_10)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6187 365.578C47.5529 366.482 48.2271 367.288 49.1479 367.354C50.0522 367.42 50.858 366.745 50.9237 365.825C50.9895 364.92 50.3153 364.114 49.3945 364.048C48.4902 363.983 47.6845 364.657 47.6187 365.578Z",
    fill: "url(#paint217_linear_935_10)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6187 365.578C47.5529 366.482 48.2271 367.288 49.1479 367.354C50.0522 367.42 50.858 366.745 50.9237 365.825C50.9895 364.92 50.3153 364.114 49.3945 364.048C48.4902 363.983 47.6845 364.657 47.6187 365.578Z",
    fill: "url(#paint218_linear_935_10)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6875 351.452C48.6218 352.356 49.2959 353.162 50.2167 353.228C51.1211 353.294 51.9268 352.62 51.9926 351.699C52.0583 350.794 51.3842 349.988 50.4634 349.923C49.559 349.857 48.7533 350.531 48.6875 351.452Z",
    fill: "url(#paint219_linear_935_10)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6875 351.452C48.6218 352.356 49.2959 353.162 50.2167 353.228C51.1211 353.294 51.9268 352.62 51.9926 351.699C52.0583 350.794 51.3842 349.988 50.4634 349.923C49.559 349.857 48.7533 350.531 48.6875 351.452Z",
    fill: "url(#paint220_linear_935_10)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6875 351.452C48.6218 352.356 49.2959 353.162 50.2167 353.228C51.1211 353.294 51.9268 352.62 51.9926 351.699C52.0583 350.794 51.3842 349.988 50.4634 349.923C49.559 349.857 48.7533 350.531 48.6875 351.452Z",
    fill: "url(#paint221_linear_935_10)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7564 337.326C49.6906 338.231 50.3648 339.036 51.2856 339.102C52.1899 339.168 52.9956 338.494 53.0614 337.573C53.1272 336.668 52.453 335.863 51.5322 335.797C50.6279 335.731 49.8222 336.405 49.7564 337.326Z",
    fill: "url(#paint222_linear_935_10)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7564 337.326C49.6906 338.231 50.3648 339.036 51.2856 339.102C52.1899 339.168 52.9956 338.494 53.0614 337.573C53.1272 336.668 52.453 335.863 51.5322 335.797C50.6279 335.731 49.8222 336.405 49.7564 337.326Z",
    fill: "url(#paint223_linear_935_10)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7564 337.326C49.6906 338.231 50.3648 339.036 51.2856 339.102C52.1899 339.168 52.9956 338.494 53.0614 337.573C53.1272 336.668 52.453 335.863 51.5322 335.797C50.6279 335.731 49.8222 336.405 49.7564 337.326Z",
    fill: "url(#paint224_linear_935_10)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1137 323.447C54.1794 322.543 53.5053 321.737 52.5845 321.671C51.6801 321.605 50.8744 322.279 50.8086 323.2C50.7429 324.105 51.417 324.911 52.3378 324.976C53.2422 325.042 54.0479 324.368 54.1137 323.447Z",
    fill: "url(#paint225_linear_935_10)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1137 323.447C54.1794 322.543 53.5053 321.737 52.5845 321.671C51.6801 321.605 50.8744 322.279 50.8086 323.2C50.7429 324.105 51.417 324.911 52.3378 324.976C53.2422 325.042 54.0479 324.368 54.1137 323.447Z",
    fill: "url(#paint226_linear_935_10)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1137 323.447C54.1794 322.543 53.5053 321.737 52.5845 321.671C51.6801 321.605 50.8744 322.279 50.8086 323.2C50.7429 324.105 51.417 324.911 52.3378 324.976C53.2422 325.042 54.0479 324.368 54.1137 323.447Z",
    fill: "url(#paint227_linear_935_10)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1825 309.321C55.2483 308.417 54.5741 307.611 53.6533 307.545C52.749 307.479 51.9432 308.154 51.8775 309.075C51.8117 309.979 52.4859 310.785 53.4067 310.851C54.311 310.916 55.1167 310.242 55.1825 309.321Z",
    fill: "url(#paint228_linear_935_10)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1825 309.321C55.2483 308.417 54.5741 307.611 53.6533 307.545C52.749 307.479 51.9432 308.154 51.8775 309.075C51.8117 309.979 52.4859 310.785 53.4067 310.851C54.311 310.916 55.1167 310.242 55.1825 309.321Z",
    fill: "url(#paint229_linear_935_10)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1825 309.321C55.2483 308.417 54.5741 307.611 53.6533 307.545C52.749 307.479 51.9432 308.154 51.8775 309.075C51.8117 309.979 52.4859 310.785 53.4067 310.851C54.311 310.916 55.1167 310.242 55.1825 309.321Z",
    fill: "url(#paint230_linear_935_10)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2514 295.195C56.3171 294.291 55.643 293.485 54.7222 293.419C53.8178 293.354 53.0121 294.028 52.9463 294.949C52.8806 295.87 53.5547 296.659 54.4755 296.725C55.3799 296.79 56.1856 296.116 56.2514 295.195Z",
    fill: "url(#paint231_linear_935_10)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2514 295.195C56.3171 294.291 55.643 293.485 54.7222 293.419C53.8178 293.354 53.0121 294.028 52.9463 294.949C52.8806 295.87 53.5547 296.659 54.4755 296.725C55.3799 296.79 56.1856 296.116 56.2514 295.195Z",
    fill: "url(#paint232_linear_935_10)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2514 295.195C56.3171 294.291 55.643 293.485 54.7222 293.419C53.8178 293.354 53.0121 294.028 52.9463 294.949C52.8806 295.87 53.5547 296.659 54.4755 296.725C55.3799 296.79 56.1856 296.116 56.2514 295.195Z",
    fill: "url(#paint233_linear_935_10)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3368 281.07C57.4026 280.165 56.7284 279.359 55.8076 279.293C54.9032 279.228 54.0975 279.902 54.0318 280.823C53.966 281.727 54.6402 282.533 55.561 282.599C56.4653 282.665 57.271 281.99 57.3368 281.07Z",
    fill: "url(#paint234_linear_935_10)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3368 281.07C57.4026 280.165 56.7284 279.359 55.8076 279.293C54.9032 279.228 54.0975 279.902 54.0318 280.823C53.966 281.727 54.6402 282.533 55.561 282.599C56.4653 282.665 57.271 281.99 57.3368 281.07Z",
    fill: "url(#paint235_linear_935_10)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3368 281.07C57.4026 280.165 56.7284 279.359 55.8076 279.293C54.9032 279.228 54.0975 279.902 54.0318 280.823C53.966 281.727 54.6402 282.533 55.561 282.599C56.4653 282.665 57.271 281.99 57.3368 281.07Z",
    fill: "url(#paint236_linear_935_10)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7036 386.133C37.6379 387.038 38.312 387.844 39.2328 387.909C40.1372 387.975 40.9429 387.301 41.0087 386.38C41.0745 385.476 40.4003 384.67 39.4795 384.604C38.5587 384.538 37.7694 385.213 37.7036 386.133Z",
    fill: "url(#paint237_linear_935_10)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7036 386.133C37.6379 387.038 38.312 387.844 39.2328 387.909C40.1372 387.975 40.9429 387.301 41.0087 386.38C41.0745 385.476 40.4003 384.67 39.4795 384.604C38.5587 384.538 37.7694 385.213 37.7036 386.133Z",
    fill: "url(#paint238_linear_935_10)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7036 386.133C37.6379 387.038 38.312 387.844 39.2328 387.909C40.1372 387.975 40.9429 387.301 41.0087 386.38C41.0745 385.476 40.4003 384.67 39.4795 384.604C38.5587 384.538 37.7694 385.213 37.7036 386.133Z",
    fill: "url(#paint239_linear_935_10)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7725 372.008C38.7067 372.912 39.3809 373.718 40.3017 373.784C41.2061 373.849 42.0118 373.175 42.0775 372.254C42.1433 371.35 41.4691 370.544 40.5483 370.478C39.644 370.413 38.8383 371.087 38.7725 372.008Z",
    fill: "url(#paint240_linear_935_10)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7725 372.008C38.7067 372.912 39.3809 373.718 40.3017 373.784C41.2061 373.849 42.0118 373.175 42.0775 372.254C42.1433 371.35 41.4691 370.544 40.5483 370.478C39.644 370.413 38.8383 371.087 38.7725 372.008Z",
    fill: "url(#paint241_linear_935_10)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7725 372.008C38.7067 372.912 39.3809 373.718 40.3017 373.784C41.2061 373.849 42.0118 373.175 42.0775 372.254C42.1433 371.35 41.4691 370.544 40.5483 370.478C39.644 370.413 38.8383 371.087 38.7725 372.008Z",
    fill: "url(#paint242_linear_935_10)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8413 357.882C39.7756 358.786 40.4497 359.592 41.3705 359.658C42.2749 359.724 43.0806 359.049 43.1464 358.128C43.2122 357.224 42.538 356.418 41.6172 356.352C40.7128 356.287 39.9071 356.961 39.8413 357.882Z",
    fill: "url(#paint243_linear_935_10)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8413 357.882C39.7756 358.786 40.4497 359.592 41.3705 359.658C42.2749 359.724 43.0806 359.049 43.1464 358.128C43.2122 357.224 42.538 356.418 41.6172 356.352C40.7128 356.287 39.9071 356.961 39.8413 357.882Z",
    fill: "url(#paint244_linear_935_10)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8413 357.882C39.7756 358.786 40.4497 359.592 41.3705 359.658C42.2749 359.724 43.0806 359.049 43.1464 358.128C43.2122 357.224 42.538 356.418 41.6172 356.352C40.7128 356.287 39.9071 356.961 39.8413 357.882Z",
    fill: "url(#paint245_linear_935_10)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9102 343.756C40.8444 344.66 41.5186 345.466 42.4394 345.532C43.3438 345.598 44.1495 344.924 44.2152 344.003C44.281 343.098 43.6068 342.292 42.686 342.227C41.7817 342.161 40.976 342.835 40.9102 343.756Z",
    fill: "url(#paint246_linear_935_10)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9102 343.756C40.8444 344.66 41.5186 345.466 42.4394 345.532C43.3438 345.598 44.1495 344.924 44.2152 344.003C44.281 343.098 43.6068 342.292 42.686 342.227C41.7817 342.161 40.976 342.835 40.9102 343.756Z",
    fill: "url(#paint247_linear_935_10)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9102 343.756C40.8444 344.66 41.5186 345.466 42.4394 345.532C43.3438 345.598 44.1495 344.924 44.2152 344.003C44.281 343.098 43.6068 342.292 42.686 342.227C41.7817 342.161 40.976 342.835 40.9102 343.756Z",
    fill: "url(#paint248_linear_935_10)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M41.979 329.63C41.9133 330.535 42.5874 331.34 43.5082 331.406C44.4126 331.472 45.2183 330.798 45.2841 329.877C45.3498 328.972 44.6757 328.167 43.7549 328.101C42.8505 328.035 42.0448 328.709 41.979 329.63Z",
    fill: "url(#paint249_linear_935_10)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M41.979 329.63C41.9133 330.535 42.5874 331.34 43.5082 331.406C44.4126 331.472 45.2183 330.798 45.2841 329.877C45.3498 328.972 44.6757 328.167 43.7549 328.101C42.8505 328.035 42.0448 328.709 41.979 329.63Z",
    fill: "url(#paint250_linear_935_10)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M41.979 329.63C41.9133 330.535 42.5874 331.34 43.5082 331.406C44.4126 331.472 45.2183 330.798 45.2841 329.877C45.3498 328.972 44.6757 328.167 43.7549 328.101C42.8505 328.035 42.0448 328.709 41.979 329.63Z",
    fill: "url(#paint251_linear_935_10)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3529 315.751C46.4187 314.847 45.7445 314.041 44.8237 313.975C43.9194 313.909 43.1137 314.583 43.0479 315.504C42.9821 316.409 43.6563 317.215 44.5771 317.28C45.4814 317.346 46.2872 316.672 46.3529 315.751Z",
    fill: "url(#paint252_linear_935_10)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3529 315.751C46.4187 314.847 45.7445 314.041 44.8237 313.975C43.9194 313.909 43.1137 314.583 43.0479 315.504C42.9821 316.409 43.6563 317.215 44.5771 317.28C45.4814 317.346 46.2872 316.672 46.3529 315.751Z",
    fill: "url(#paint253_linear_935_10)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3529 315.751C46.4187 314.847 45.7445 314.041 44.8237 313.975C43.9194 313.909 43.1137 314.583 43.0479 315.504C42.9821 316.409 43.6563 317.215 44.5771 317.28C45.4814 317.346 46.2872 316.672 46.3529 315.751Z",
    fill: "url(#paint254_linear_935_10)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4213 301.625C47.4871 300.721 46.8129 299.915 45.8921 299.849C44.9877 299.783 44.182 300.458 44.1162 301.379C44.0505 302.283 44.7246 303.089 45.6454 303.155C46.5498 303.22 47.3555 302.546 47.4213 301.625Z",
    fill: "url(#paint255_linear_935_10)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4213 301.625C47.4871 300.721 46.8129 299.915 45.8921 299.849C44.9877 299.783 44.182 300.458 44.1162 301.379C44.0505 302.283 44.7246 303.089 45.6454 303.155C46.5498 303.22 47.3555 302.546 47.4213 301.625Z",
    fill: "url(#paint256_linear_935_10)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4213 301.625C47.4871 300.721 46.8129 299.915 45.8921 299.849C44.9877 299.783 44.182 300.458 44.1162 301.379C44.0505 302.283 44.7246 303.089 45.6454 303.155C46.5498 303.22 47.3555 302.546 47.4213 301.625Z",
    fill: "url(#paint257_linear_935_10)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4901 287.499C48.5559 286.595 47.8817 285.789 46.9609 285.723C46.0566 285.658 45.2509 286.332 45.1851 287.253C45.1193 288.157 45.7935 288.963 46.7143 289.029C47.6187 289.094 48.4244 288.42 48.4901 287.499Z",
    fill: "url(#paint258_linear_935_10)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4901 287.499C48.5559 286.595 47.8817 285.789 46.9609 285.723C46.0566 285.658 45.2509 286.332 45.1851 287.253C45.1193 288.157 45.7935 288.963 46.7143 289.029C47.6187 289.094 48.4244 288.42 48.4901 287.499Z",
    fill: "url(#paint259_linear_935_10)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4901 287.499C48.5559 286.595 47.8817 285.789 46.9609 285.723C46.0566 285.658 45.2509 286.332 45.1851 287.253C45.1193 288.157 45.7935 288.963 46.7143 289.029C47.6187 289.094 48.4244 288.42 48.4901 287.499Z",
    fill: "url(#paint260_linear_935_10)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8931 378.437C29.8273 379.342 30.5015 380.148 31.4223 380.213C32.3267 380.279 33.1324 379.605 33.1981 378.684C33.2639 377.78 32.5897 376.974 31.6689 376.908C30.7646 376.842 29.9589 377.517 29.8931 378.437Z",
    fill: "url(#paint261_linear_935_10)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8931 378.437C29.8273 379.342 30.5015 380.148 31.4223 380.213C32.3267 380.279 33.1324 379.605 33.1981 378.684C33.2639 377.78 32.5897 376.974 31.6689 376.908C30.7646 376.842 29.9589 377.517 29.8931 378.437Z",
    fill: "url(#paint262_linear_935_10)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8931 378.437C29.8273 379.342 30.5015 380.148 31.4223 380.213C32.3267 380.279 33.1324 379.605 33.1981 378.684C33.2639 377.78 32.5897 376.974 31.6689 376.908C30.7646 376.842 29.9589 377.517 29.8931 378.437Z",
    fill: "url(#paint263_linear_935_10)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9619 364.312C30.8962 365.216 31.5703 366.022 32.4911 366.088C33.3955 366.153 34.2012 365.479 34.267 364.558C34.3328 363.654 33.6586 362.848 32.7378 362.782C31.8334 362.716 31.0277 363.391 30.9619 364.312Z",
    fill: "url(#paint264_linear_935_10)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9619 364.312C30.8962 365.216 31.5703 366.022 32.4911 366.088C33.3955 366.153 34.2012 365.479 34.267 364.558C34.3328 363.654 33.6586 362.848 32.7378 362.782C31.8334 362.716 31.0277 363.391 30.9619 364.312Z",
    fill: "url(#paint265_linear_935_10)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9619 364.312C30.8962 365.216 31.5703 366.022 32.4911 366.088C33.3955 366.153 34.2012 365.479 34.267 364.558C34.3328 363.654 33.6586 362.848 32.7378 362.782C31.8334 362.716 31.0277 363.391 30.9619 364.312Z",
    fill: "url(#paint266_linear_935_10)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0308 350.186C31.965 351.09 32.6392 351.896 33.56 351.962C34.4644 352.028 35.2701 351.353 35.3358 350.432C35.4016 349.528 34.7274 348.722 33.8066 348.656C32.9023 348.591 32.0966 349.265 32.0308 350.186Z",
    fill: "url(#paint267_linear_935_10)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0308 350.186C31.965 351.09 32.6392 351.896 33.56 351.962C34.4644 352.028 35.2701 351.353 35.3358 350.432C35.4016 349.528 34.7274 348.722 33.8066 348.656C32.9023 348.591 32.0966 349.265 32.0308 350.186Z",
    fill: "url(#paint268_linear_935_10)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0308 350.186C31.965 351.09 32.6392 351.896 33.56 351.962C34.4644 352.028 35.2701 351.353 35.3358 350.432C35.4016 349.528 34.7274 348.722 33.8066 348.656C32.9023 348.591 32.0966 349.265 32.0308 350.186Z",
    fill: "url(#paint269_linear_935_10)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0996 336.06C33.0339 336.964 33.708 337.77 34.6288 337.836C35.5332 337.902 36.3389 337.228 36.4047 336.307C36.4705 335.402 35.7963 334.596 34.8755 334.531C33.9711 334.465 33.1654 335.139 33.0996 336.06Z",
    fill: "url(#paint270_linear_935_10)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0996 336.06C33.0339 336.964 33.708 337.77 34.6288 337.836C35.5332 337.902 36.3389 337.228 36.4047 336.307C36.4705 335.402 35.7963 334.596 34.8755 334.531C33.9711 334.465 33.1654 335.139 33.0996 336.06Z",
    fill: "url(#paint271_linear_935_10)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0996 336.06C33.0339 336.964 33.708 337.77 34.6288 337.836C35.5332 337.902 36.3389 337.228 36.4047 336.307C36.4705 335.402 35.7963 334.596 34.8755 334.531C33.9711 334.465 33.1654 335.139 33.0996 336.06Z",
    fill: "url(#paint272_linear_935_10)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4569 322.181C37.5227 321.276 36.8485 320.471 35.9277 320.405C35.0234 320.339 34.2177 321.013 34.1519 321.934C34.0861 322.839 34.7603 323.644 35.6811 323.71C36.5854 323.776 37.3912 323.102 37.4569 322.181Z",
    fill: "url(#paint273_linear_935_10)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4569 322.181C37.5227 321.276 36.8485 320.471 35.9277 320.405C35.0234 320.339 34.2177 321.013 34.1519 321.934C34.0861 322.839 34.7603 323.644 35.6811 323.71C36.5854 323.776 37.3912 323.102 37.4569 322.181Z",
    fill: "url(#paint274_linear_935_10)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4569 322.181C37.5227 321.276 36.8485 320.471 35.9277 320.405C35.0234 320.339 34.2177 321.013 34.1519 321.934C34.0861 322.839 34.7603 323.644 35.6811 323.71C36.5854 323.776 37.3912 323.102 37.4569 322.181Z",
    fill: "url(#paint275_linear_935_10)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5258 308.055C38.5915 307.151 37.9174 306.345 36.9966 306.279C36.0922 306.213 35.2865 306.887 35.2207 307.808C35.155 308.713 35.8291 309.519 36.7499 309.584C37.6543 309.65 38.46 308.976 38.5258 308.055Z",
    fill: "url(#paint276_linear_935_10)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5258 308.055C38.5915 307.151 37.9174 306.345 36.9966 306.279C36.0922 306.213 35.2865 306.887 35.2207 307.808C35.155 308.713 35.8291 309.519 36.7499 309.584C37.6543 309.65 38.46 308.976 38.5258 308.055Z",
    fill: "url(#paint277_linear_935_10)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5258 308.055C38.5915 307.151 37.9174 306.345 36.9966 306.279C36.0922 306.213 35.2865 306.887 35.2207 307.808C35.155 308.713 35.8291 309.519 36.7499 309.584C37.6543 309.65 38.46 308.976 38.5258 308.055Z",
    fill: "url(#paint278_linear_935_10)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5946 293.929C39.6604 293.025 38.9862 292.219 38.0654 292.153C37.1611 292.087 36.3554 292.762 36.2896 293.682C36.2238 294.587 36.898 295.393 37.8188 295.458C38.7231 295.524 39.5288 294.85 39.5946 293.929Z",
    fill: "url(#paint279_linear_935_10)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5946 293.929C39.6604 293.025 38.9862 292.219 38.0654 292.153C37.1611 292.087 36.3554 292.762 36.2896 293.682C36.2238 294.587 36.898 295.393 37.8188 295.458C38.7231 295.524 39.5288 294.85 39.5946 293.929Z",
    fill: "url(#paint280_linear_935_10)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5946 293.929C39.6604 293.025 38.9862 292.219 38.0654 292.153C37.1611 292.087 36.3554 292.762 36.2896 293.682C36.2238 294.587 36.898 295.393 37.8188 295.458C38.7231 295.524 39.5288 294.85 39.5946 293.929Z",
    fill: "url(#paint281_linear_935_10)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6635 279.803C40.7292 278.899 40.0551 278.093 39.1343 278.027C38.2299 277.962 37.4242 278.636 37.3584 279.557C37.2927 280.461 37.9668 281.267 38.8876 281.333C39.792 281.398 40.5977 280.724 40.6635 279.803Z",
    fill: "url(#paint282_linear_935_10)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6635 279.803C40.7292 278.899 40.0551 278.093 39.1343 278.027C38.2299 277.962 37.4242 278.636 37.3584 279.557C37.2927 280.461 37.9668 281.267 38.8876 281.333C39.792 281.398 40.5977 280.724 40.6635 279.803Z",
    fill: "url(#paint283_linear_935_10)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6635 279.803C40.7292 278.899 40.0551 278.093 39.1343 278.027C38.2299 277.962 37.4242 278.636 37.3584 279.557C37.2927 280.461 37.9668 281.267 38.8876 281.333C39.792 281.398 40.5977 280.724 40.6635 279.803Z",
    fill: "url(#paint284_linear_935_10)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 370.741C22.05 371.646 22.7241 372.452 23.645 372.517C24.5493 372.583 25.355 371.909 25.4208 370.988C25.4866 370.084 24.8124 369.278 23.8916 369.212C22.9872 369.146 22.1815 369.821 22.1158 370.741Z",
    fill: "url(#paint285_linear_935_10)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 370.741C22.05 371.646 22.7241 372.452 23.645 372.517C24.5493 372.583 25.355 371.909 25.4208 370.988C25.4866 370.084 24.8124 369.278 23.8916 369.212C22.9872 369.146 22.1815 369.821 22.1158 370.741Z",
    fill: "url(#paint286_linear_935_10)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 370.741C22.05 371.646 22.7241 372.452 23.645 372.517C24.5493 372.583 25.355 371.909 25.4208 370.988C25.4866 370.084 24.8124 369.278 23.8916 369.212C22.9872 369.146 22.1815 369.821 22.1158 370.741Z",
    fill: "url(#paint287_linear_935_10)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 356.616C23.1188 357.52 23.793 358.326 24.7138 358.392C25.6182 358.457 26.4239 357.783 26.4896 356.862C26.5554 355.958 25.8813 355.152 24.9604 355.086C24.0561 355.02 23.2504 355.695 23.1846 356.616Z",
    fill: "url(#paint288_linear_935_10)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 356.616C23.1188 357.52 23.793 358.326 24.7138 358.392C25.6182 358.457 26.4239 357.783 26.4896 356.862C26.5554 355.958 25.8813 355.152 24.9604 355.086C24.0561 355.02 23.2504 355.695 23.1846 356.616Z",
    fill: "url(#paint289_linear_935_10)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 356.616C23.1188 357.52 23.793 358.326 24.7138 358.392C25.6182 358.457 26.4239 357.783 26.4896 356.862C26.5554 355.958 25.8813 355.152 24.9604 355.086C24.0561 355.02 23.2504 355.695 23.1846 356.616Z",
    fill: "url(#paint290_linear_935_10)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2535 342.49C24.1877 343.394 24.8618 344.2 25.7826 344.266C26.687 344.332 27.4927 343.657 27.5585 342.736C27.6243 341.832 26.9501 341.026 26.0293 340.96C25.1249 340.895 24.3192 341.569 24.2535 342.49Z",
    fill: "url(#paint291_linear_935_10)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2535 342.49C24.1877 343.394 24.8618 344.2 25.7826 344.266C26.687 344.332 27.4927 343.657 27.5585 342.736C27.6243 341.832 26.9501 341.026 26.0293 340.96C25.1249 340.895 24.3192 341.569 24.2535 342.49Z",
    fill: "url(#paint292_linear_935_10)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2535 342.49C24.1877 343.394 24.8618 344.2 25.7826 344.266C26.687 344.332 27.4927 343.657 27.5585 342.736C27.6243 341.832 26.9501 341.026 26.0293 340.96C25.1249 340.895 24.3192 341.569 24.2535 342.49Z",
    fill: "url(#paint293_linear_935_10)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3223 328.364C25.2565 329.268 25.9307 330.074 26.8515 330.14C27.7559 330.206 28.5616 329.531 28.6273 328.611C28.6931 327.706 28.0189 326.9 27.0981 326.835C26.1938 326.769 25.3881 327.443 25.3223 328.364Z",
    fill: "url(#paint294_linear_935_10)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3223 328.364C25.2565 329.268 25.9307 330.074 26.8515 330.14C27.7559 330.206 28.5616 329.531 28.6273 328.611C28.6931 327.706 28.0189 326.9 27.0981 326.835C26.1938 326.769 25.3881 327.443 25.3223 328.364Z",
    fill: "url(#paint295_linear_935_10)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3223 328.364C25.2565 329.268 25.9307 330.074 26.8515 330.14C27.7559 330.206 28.5616 329.531 28.6273 328.611C28.6931 327.706 28.0189 326.9 27.0981 326.835C26.1938 326.769 25.3881 327.443 25.3223 328.364Z",
    fill: "url(#paint296_linear_935_10)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6962 314.485C29.762 313.58 29.0878 312.775 28.167 312.709C27.2626 312.643 26.4569 313.317 26.3911 314.238C26.3254 315.143 26.9995 315.948 27.9203 316.014C28.8247 316.08 29.6304 315.406 29.6962 314.485Z",
    fill: "url(#paint297_linear_935_10)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6962 314.485C29.762 313.58 29.0878 312.775 28.167 312.709C27.2626 312.643 26.4569 313.317 26.3911 314.238C26.3254 315.143 26.9995 315.948 27.9203 316.014C28.8247 316.08 29.6304 315.406 29.6962 314.485Z",
    fill: "url(#paint298_linear_935_10)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6962 314.485C29.762 313.58 29.0878 312.775 28.167 312.709C27.2626 312.643 26.4569 313.317 26.3911 314.238C26.3254 315.143 26.9995 315.948 27.9203 316.014C28.8247 316.08 29.6304 315.406 29.6962 314.485Z",
    fill: "url(#paint299_linear_935_10)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M30.765 300.359C30.8308 299.454 30.1566 298.649 29.2358 298.583C28.3315 298.517 27.5258 299.191 27.46 300.112C27.3942 301.017 28.0684 301.822 28.9892 301.888C29.8936 301.954 30.6993 301.28 30.765 300.359Z",
    fill: "url(#paint300_linear_935_10)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M30.765 300.359C30.8308 299.454 30.1566 298.649 29.2358 298.583C28.3315 298.517 27.5258 299.191 27.46 300.112C27.3942 301.017 28.0684 301.822 28.9892 301.888C29.8936 301.954 30.6993 301.28 30.765 300.359Z",
    fill: "url(#paint301_linear_935_10)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30.765 300.359C30.8308 299.454 30.1566 298.649 29.2358 298.583C28.3315 298.517 27.5258 299.191 27.46 300.112C27.3942 301.017 28.0684 301.822 28.9892 301.888C29.8936 301.954 30.6993 301.28 30.765 300.359Z",
    fill: "url(#paint302_linear_935_10)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8334 286.233C31.8992 285.329 31.225 284.523 30.3042 284.457C29.3998 284.391 28.5941 285.066 28.5284 285.986C28.4626 286.891 29.1367 287.697 30.0576 287.762C30.9784 287.828 31.7676 287.154 31.8334 286.233Z",
    fill: "url(#paint303_linear_935_10)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8334 286.233C31.8992 285.329 31.225 284.523 30.3042 284.457C29.3998 284.391 28.5941 285.066 28.5284 285.986C28.4626 286.891 29.1367 287.697 30.0576 287.762C30.9784 287.828 31.7676 287.154 31.8334 286.233Z",
    fill: "url(#paint304_linear_935_10)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8334 286.233C31.8992 285.329 31.225 284.523 30.3042 284.457C29.3998 284.391 28.5941 285.066 28.5284 285.986C28.4626 286.891 29.1367 287.697 30.0576 287.762C30.9784 287.828 31.7676 287.154 31.8334 286.233Z",
    fill: "url(#paint305_linear_935_10)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2891 363.045C14.2233 363.95 14.8975 364.756 15.8183 364.821C16.7227 364.887 17.5284 364.213 17.5941 363.292C17.6599 362.388 16.9857 361.582 16.0649 361.516C15.1606 361.45 14.3549 362.124 14.2891 363.045Z",
    fill: "url(#paint306_linear_935_10)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2891 363.045C14.2233 363.95 14.8975 364.756 15.8183 364.821C16.7227 364.887 17.5284 364.213 17.5941 363.292C17.6599 362.388 16.9857 361.582 16.0649 361.516C15.1606 361.45 14.3549 362.124 14.2891 363.045Z",
    fill: "url(#paint307_linear_935_10)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2891 363.045C14.2233 363.95 14.8975 364.756 15.8183 364.821C16.7227 364.887 17.5284 364.213 17.5941 363.292C17.6599 362.388 16.9857 361.582 16.0649 361.516C15.1606 361.45 14.3549 362.124 14.2891 363.045Z",
    fill: "url(#paint308_linear_935_10)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3579 348.92C15.2922 349.824 15.9663 350.63 16.8871 350.696C17.7915 350.761 18.5972 350.087 18.663 349.166C18.7288 348.262 18.0546 347.456 17.1338 347.39C16.213 347.324 15.4237 347.999 15.3579 348.92Z",
    fill: "url(#paint309_linear_935_10)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3579 348.92C15.2922 349.824 15.9663 350.63 16.8871 350.696C17.7915 350.761 18.5972 350.087 18.663 349.166C18.7288 348.262 18.0546 347.456 17.1338 347.39C16.213 347.324 15.4237 347.999 15.3579 348.92Z",
    fill: "url(#paint310_linear_935_10)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3579 348.92C15.2922 349.824 15.9663 350.63 16.8871 350.696C17.7915 350.761 18.5972 350.087 18.663 349.166C18.7288 348.262 18.0546 347.456 17.1338 347.39C16.213 347.324 15.4237 347.999 15.3579 348.92Z",
    fill: "url(#paint311_linear_935_10)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3579 348.92C15.2922 349.824 15.9663 350.63 16.8871 350.696C17.7915 350.761 18.5972 350.087 18.663 349.166C18.7288 348.262 18.0546 347.456 17.1338 347.39C16.213 347.324 15.4237 347.999 15.3579 348.92Z",
    fill: "url(#paint312_linear_935_10)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4263 334.794C16.3605 335.698 17.0347 336.504 17.9555 336.57C18.8599 336.635 19.6656 335.961 19.7313 335.04C19.7971 334.136 19.123 333.33 18.2021 333.264C17.2978 333.199 16.4921 333.873 16.4263 334.794Z",
    fill: "url(#paint313_linear_935_10)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4263 334.794C16.3605 335.698 17.0347 336.504 17.9555 336.57C18.8599 336.635 19.6656 335.961 19.7313 335.04C19.7971 334.136 19.123 333.33 18.2021 333.264C17.2978 333.199 16.4921 333.873 16.4263 334.794Z",
    fill: "url(#paint314_linear_935_10)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4263 334.794C16.3605 335.698 17.0347 336.504 17.9555 336.57C18.8599 336.635 19.6656 335.961 19.7313 335.04C19.7971 334.136 19.123 333.33 18.2021 333.264C17.2978 333.199 16.4921 333.873 16.4263 334.794Z",
    fill: "url(#paint315_linear_935_10)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4263 334.794C16.3605 335.698 17.0347 336.504 17.9555 336.57C18.8599 336.635 19.6656 335.961 19.7313 335.04C19.7971 334.136 19.123 333.33 18.2021 333.264C17.2978 333.199 16.4921 333.873 16.4263 334.794Z",
    fill: "url(#paint316_linear_935_10)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8002 320.915C20.866 320.01 20.1918 319.204 19.271 319.139C18.3666 319.073 17.5609 319.747 17.4952 320.668C17.4294 321.572 18.1035 322.378 19.0243 322.444C19.9287 322.51 20.7344 321.835 20.8002 320.915Z",
    fill: "url(#paint317_linear_935_10)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8002 320.915C20.866 320.01 20.1918 319.204 19.271 319.139C18.3666 319.073 17.5609 319.747 17.4952 320.668C17.4294 321.572 18.1035 322.378 19.0243 322.444C19.9287 322.51 20.7344 321.835 20.8002 320.915Z",
    fill: "url(#paint318_linear_935_10)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8002 320.915C20.866 320.01 20.1918 319.204 19.271 319.139C18.3666 319.073 17.5609 319.747 17.4952 320.668C17.4294 321.572 18.1035 322.378 19.0243 322.444C19.9287 322.51 20.7344 321.835 20.8002 320.915Z",
    fill: "url(#paint319_linear_935_10)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8002 320.915C20.866 320.01 20.1918 319.204 19.271 319.139C18.3666 319.073 17.5609 319.747 17.4952 320.668C17.4294 321.572 18.1035 322.378 19.0243 322.444C19.9287 322.51 20.7344 321.835 20.8002 320.915Z",
    fill: "url(#paint320_linear_935_10)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M21.869 306.789C21.9348 305.884 21.2606 305.079 20.3398 305.013C19.4355 304.947 18.6298 305.621 18.564 306.542C18.4982 307.447 19.1724 308.252 20.0932 308.318C20.9976 308.384 21.8033 307.71 21.869 306.789Z",
    fill: "url(#paint321_linear_935_10)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M21.869 306.789C21.9348 305.884 21.2606 305.079 20.3398 305.013C19.4355 304.947 18.6298 305.621 18.564 306.542C18.4982 307.447 19.1724 308.252 20.0932 308.318C20.9976 308.384 21.8033 307.71 21.869 306.789Z",
    fill: "url(#paint322_linear_935_10)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M21.869 306.789C21.9348 305.884 21.2606 305.079 20.3398 305.013C19.4355 304.947 18.6298 305.621 18.564 306.542C18.4982 307.447 19.1724 308.252 20.0932 308.318C20.9976 308.384 21.8033 307.71 21.869 306.789Z",
    fill: "url(#paint323_linear_935_10)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9379 292.663C23.0037 291.758 22.3295 290.953 21.4087 290.887C20.5043 290.821 19.6986 291.495 19.6328 292.416C19.5671 293.321 20.2412 294.126 21.162 294.192C22.0664 294.258 22.8721 293.584 22.9379 292.663Z",
    fill: "url(#paint324_linear_935_10)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9379 292.663C23.0037 291.758 22.3295 290.953 21.4087 290.887C20.5043 290.821 19.6986 291.495 19.6328 292.416C19.5671 293.321 20.2412 294.126 21.162 294.192C22.0664 294.258 22.8721 293.584 22.9379 292.663Z",
    fill: "url(#paint325_linear_935_10)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9379 292.663C23.0037 291.758 22.3295 290.953 21.4087 290.887C20.5043 290.821 19.6986 291.495 19.6328 292.416C19.5671 293.321 20.2412 294.126 21.162 294.192C22.0664 294.258 22.8721 293.584 22.9379 292.663Z",
    fill: "url(#paint326_linear_935_10)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0065 278.537C24.0394 278.142 23.9243 277.781 23.727 277.485C22.9049 278.192 22.0827 278.915 21.2935 279.672C21.5565 279.886 21.869 280.034 22.2307 280.066C23.1351 280.132 23.9408 279.458 24.0065 278.537Z",
    fill: "url(#paint327_linear_935_10)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0065 278.537C24.0394 278.142 23.9243 277.781 23.727 277.485C22.9049 278.192 22.0827 278.915 21.2935 279.672C21.5565 279.886 21.869 280.034 22.2307 280.066C23.1351 280.132 23.9408 279.458 24.0065 278.537Z",
    fill: "url(#paint328_linear_935_10)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0065 278.537C24.0394 278.142 23.9243 277.781 23.727 277.485C22.9049 278.192 22.0827 278.915 21.2935 279.672C21.5565 279.886 21.869 280.034 22.2307 280.066C23.1351 280.132 23.9408 279.458 24.0065 278.537Z",
    fill: "url(#paint329_linear_935_10)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52787 355.366C6.46209 356.27 7.13626 357.076 8.05706 357.142C8.96143 357.208 9.76713 356.533 9.8329 355.612C9.89867 354.708 9.22451 353.902 8.30371 353.836C7.39934 353.771 6.59364 354.445 6.52787 355.366Z",
    fill: "url(#paint330_linear_935_10)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52787 355.366C6.46209 356.27 7.13626 357.076 8.05706 357.142C8.96143 357.208 9.76713 356.533 9.8329 355.612C9.89867 354.708 9.22451 353.902 8.30371 353.836C7.39934 353.771 6.59364 354.445 6.52787 355.366Z",
    fill: "url(#paint331_linear_935_10)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52787 355.366C6.46209 356.27 7.13626 357.076 8.05706 357.142C8.96143 357.208 9.76713 356.533 9.8329 355.612C9.89867 354.708 9.22451 353.902 8.30371 353.836C7.39934 353.771 6.59364 354.445 6.52787 355.366Z",
    fill: "url(#paint332_linear_935_10)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59671 341.24C7.53094 342.144 8.2051 342.95 9.12591 343.016C10.0303 343.082 10.836 342.408 10.9018 341.487C10.9675 340.582 10.2934 339.776 9.37255 339.711C8.46819 339.645 7.66249 340.319 7.59671 341.24Z",
    fill: "url(#paint333_linear_935_10)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59671 341.24C7.53094 342.144 8.2051 342.95 9.12591 343.016C10.0303 343.082 10.836 342.408 10.9018 341.487C10.9675 340.582 10.2934 339.776 9.37255 339.711C8.46819 339.645 7.66249 340.319 7.59671 341.24Z",
    fill: "url(#paint334_linear_935_10)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59671 341.24C7.53094 342.144 8.2051 342.95 9.12591 343.016C10.0303 343.082 10.836 342.408 10.9018 341.487C10.9675 340.582 10.2934 339.776 9.37255 339.711C8.46819 339.645 7.66249 340.319 7.59671 341.24Z",
    fill: "url(#paint335_linear_935_10)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59671 341.24C7.53094 342.144 8.2051 342.95 9.12591 343.016C10.0303 343.082 10.836 342.408 10.9018 341.487C10.9675 340.582 10.2934 339.776 9.37255 339.711C8.46819 339.645 7.66249 340.319 7.59671 341.24Z",
    fill: "url(#paint336_linear_935_10)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66556 327.114C8.59979 328.019 9.27395 328.824 10.1948 328.89C11.0991 328.956 11.9048 328.282 11.9706 327.361C12.0364 326.456 11.3622 325.651 10.4414 325.585C9.5206 325.519 8.73133 326.193 8.66556 327.114Z",
    fill: "url(#paint337_linear_935_10)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66556 327.114C8.59979 328.019 9.27395 328.824 10.1948 328.89C11.0991 328.956 11.9048 328.282 11.9706 327.361C12.0364 326.456 11.3622 325.651 10.4414 325.585C9.5206 325.519 8.73133 326.193 8.66556 327.114Z",
    fill: "url(#paint338_linear_935_10)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66556 327.114C8.59979 328.019 9.27395 328.824 10.1948 328.89C11.0991 328.956 11.9048 328.282 11.9706 327.361C12.0364 326.456 11.3622 325.651 10.4414 325.585C9.5206 325.519 8.73133 326.193 8.66556 327.114Z",
    fill: "url(#paint339_linear_935_10)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66556 327.114C8.59979 328.019 9.27395 328.824 10.1948 328.89C11.0991 328.956 11.9048 328.282 11.9706 327.361C12.0364 326.456 11.3622 325.651 10.4414 325.585C9.5206 325.519 8.73133 326.193 8.66556 327.114Z",
    fill: "url(#paint340_linear_935_10)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 313.235C13.1052 312.331 12.4311 311.525 11.5102 311.459C10.6059 311.393 9.80018 312.067 9.73441 312.988C9.66864 313.893 10.3428 314.699 11.2636 314.764C12.1844 314.83 12.9737 314.156 13.0394 313.235Z",
    fill: "url(#paint341_linear_935_10)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 313.235C13.1052 312.331 12.4311 311.525 11.5102 311.459C10.6059 311.393 9.80018 312.067 9.73441 312.988C9.66864 313.893 10.3428 314.699 11.2636 314.764C12.1844 314.83 12.9737 314.156 13.0394 313.235Z",
    fill: "url(#paint342_linear_935_10)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 313.235C13.1052 312.331 12.4311 311.525 11.5102 311.459C10.6059 311.393 9.80018 312.067 9.73441 312.988C9.66864 313.893 10.3428 314.699 11.2636 314.764C12.1844 314.83 12.9737 314.156 13.0394 313.235Z",
    fill: "url(#paint343_linear_935_10)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 313.235C13.1052 312.331 12.4311 311.525 11.5102 311.459C10.6059 311.393 9.80018 312.067 9.73441 312.988C9.66864 313.893 10.3428 314.699 11.2636 314.764C12.1844 314.83 12.9737 314.156 13.0394 313.235Z",
    fill: "url(#paint344_linear_935_10)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1083 299.109C14.1741 298.205 13.4999 297.399 12.5791 297.333C11.6747 297.267 10.869 297.942 10.8033 298.863C10.7375 299.767 11.4116 300.573 12.3325 300.639C13.2368 300.704 14.0425 300.03 14.1083 299.109Z",
    fill: "url(#paint345_linear_935_10)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1083 299.109C14.1741 298.205 13.4999 297.399 12.5791 297.333C11.6747 297.267 10.869 297.942 10.8033 298.863C10.7375 299.767 11.4116 300.573 12.3325 300.639C13.2368 300.704 14.0425 300.03 14.1083 299.109Z",
    fill: "url(#paint346_linear_935_10)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1083 299.109C14.1741 298.205 13.4999 297.399 12.5791 297.333C11.6747 297.267 10.869 297.942 10.8033 298.863C10.7375 299.767 11.4116 300.573 12.3325 300.639C13.2368 300.704 14.0425 300.03 14.1083 299.109Z",
    fill: "url(#paint347_linear_935_10)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1083 299.109C14.1741 298.205 13.4999 297.399 12.5791 297.333C11.6747 297.267 10.869 297.942 10.8033 298.863C10.7375 299.767 11.4116 300.573 12.3325 300.639C13.2368 300.704 14.0425 300.03 14.1083 299.109Z",
    fill: "url(#paint348_linear_935_10)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29899 335.32C2.20336 335.386 3.00906 334.712 3.07483 333.791C3.14061 332.886 2.46644 332.08 1.54564 332.015C0.88792 331.965 0.295973 332.311 0 332.837C0.0328859 333.445 0.0822148 334.07 0.131544 334.679C0.411074 335.04 0.822148 335.287 1.31544 335.32H1.29899Z",
    fill: "url(#paint349_linear_935_10)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29899 335.32C2.20336 335.386 3.00906 334.712 3.07483 333.791C3.14061 332.886 2.46644 332.08 1.54564 332.015C0.88792 331.965 0.295973 332.311 0 332.837C0.0328859 333.445 0.0822148 334.07 0.131544 334.679C0.411074 335.04 0.822148 335.287 1.31544 335.32H1.29899Z",
    fill: "url(#paint350_linear_935_10)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29899 335.32C2.20336 335.386 3.00906 334.712 3.07483 333.791C3.14061 332.886 2.46644 332.08 1.54564 332.015C0.88792 331.965 0.295973 332.311 0 332.837C0.0328859 333.445 0.0822148 334.07 0.131544 334.679C0.411074 335.04 0.822148 335.287 1.31544 335.32H1.29899Z",
    fill: "url(#paint351_linear_935_10)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29899 335.32C2.20336 335.386 3.00906 334.712 3.07483 333.791C3.14061 332.886 2.46644 332.08 1.54564 332.015C0.88792 331.965 0.295973 332.311 0 332.837C0.0328859 333.445 0.0822148 334.07 0.131544 334.679C0.411074 335.04 0.822148 335.287 1.31544 335.32H1.29899Z",
    fill: "url(#paint352_linear_935_10)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14345 319.665C4.20922 318.76 3.53506 317.955 2.61425 317.889C1.70989 317.823 0.904185 318.497 0.838413 319.418C0.772642 320.323 1.4468 321.128 2.36761 321.194C3.27197 321.26 4.07768 320.586 4.14345 319.665Z",
    fill: "url(#paint353_linear_935_10)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14345 319.665C4.20922 318.76 3.53506 317.955 2.61425 317.889C1.70989 317.823 0.904185 318.497 0.838413 319.418C0.772642 320.323 1.4468 321.128 2.36761 321.194C3.27197 321.26 4.07768 320.586 4.14345 319.665Z",
    fill: "url(#paint354_linear_935_10)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14345 319.665C4.20922 318.76 3.53506 317.955 2.61425 317.889C1.70989 317.823 0.904185 318.497 0.838413 319.418C0.772642 320.323 1.4468 321.128 2.36761 321.194C3.27197 321.26 4.07768 320.586 4.14345 319.665Z",
    fill: "url(#paint355_linear_935_10)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14345 319.665C4.20922 318.76 3.53506 317.955 2.61425 317.889C1.70989 317.823 0.904185 318.497 0.838413 319.418C0.772642 320.323 1.4468 321.128 2.36761 321.194C3.27197 321.26 4.07768 320.586 4.14345 319.665Z",
    fill: "url(#paint356_linear_935_10)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21266 305.539C5.24554 304.996 5.01534 304.503 4.63715 304.158C4.25896 305.111 3.89722 306.082 3.56836 307.052C4.42339 307.052 5.14688 306.394 5.21266 305.523V305.539Z",
    fill: "url(#paint357_linear_935_10)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21266 305.539C5.24554 304.996 5.01534 304.503 4.63715 304.158C4.25896 305.111 3.89722 306.082 3.56836 307.052C4.42339 307.052 5.14688 306.394 5.21266 305.523V305.539Z",
    fill: "url(#paint358_linear_935_10)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21266 305.539C5.24554 304.996 5.01534 304.503 4.63715 304.158C4.25896 305.111 3.89722 306.082 3.56836 307.052C4.42339 307.052 5.14688 306.394 5.21266 305.523V305.539Z",
    fill: "url(#paint359_linear_935_10)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21266 305.539C5.24554 304.996 5.01534 304.503 4.63715 304.158C4.25896 305.111 3.89722 306.082 3.56836 307.052C4.42339 307.052 5.14688 306.394 5.21266 305.523V305.539Z",
    fill: "url(#paint360_linear_935_10)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6117 276.038C99.6775 275.133 99.0033 274.327 98.0825 274.262C97.1782 274.196 96.3724 274.87 96.3067 275.791C96.2409 276.695 96.9151 277.501 97.8359 277.567C98.7402 277.633 99.5459 276.958 99.6117 276.038Z",
    fill: "url(#paint361_linear_935_10)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6117 276.038C99.6775 275.133 99.0033 274.327 98.0825 274.262C97.1782 274.196 96.3724 274.87 96.3067 275.791C96.2409 276.695 96.9151 277.501 97.8359 277.567C98.7402 277.633 99.5459 276.958 99.6117 276.038Z",
    fill: "url(#paint362_linear_935_10)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6117 276.038C99.6775 275.133 99.0033 274.327 98.0825 274.262C97.1782 274.196 96.3724 274.87 96.3067 275.791C96.2409 276.695 96.9151 277.501 97.8359 277.567C98.7402 277.633 99.5459 276.958 99.6117 276.038Z",
    fill: "url(#paint363_linear_935_10)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8012 268.341C91.8669 267.437 91.1928 266.631 90.272 266.565C89.3676 266.5 88.5619 267.174 88.4961 268.095C88.4304 268.999 89.1045 269.805 90.0253 269.871C90.9297 269.937 91.7354 269.262 91.8012 268.341Z",
    fill: "url(#paint364_linear_935_10)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8012 268.341C91.8669 267.437 91.1928 266.631 90.272 266.565C89.3676 266.5 88.5619 267.174 88.4961 268.095C88.4304 268.999 89.1045 269.805 90.0253 269.871C90.9297 269.937 91.7354 269.262 91.8012 268.341Z",
    fill: "url(#paint365_linear_935_10)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8012 268.341C91.8669 267.437 91.1928 266.631 90.272 266.565C89.3676 266.5 88.5619 267.174 88.4961 268.095C88.4304 268.999 89.1045 269.805 90.0253 269.871C90.9297 269.937 91.7354 269.262 91.8012 268.341Z",
    fill: "url(#paint366_linear_935_10)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M82.955 274.771C83.0207 273.867 82.3466 273.061 81.4258 272.995C80.5214 272.929 79.7157 273.604 79.6499 274.525C79.5842 275.429 80.2583 276.235 81.1791 276.301C82.0835 276.366 82.8892 275.692 82.955 274.771Z",
    fill: "url(#paint367_linear_935_10)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M82.955 274.771C83.0207 273.867 82.3466 273.061 81.4258 272.995C80.5214 272.929 79.7157 273.604 79.6499 274.525C79.5842 275.429 80.2583 276.235 81.1791 276.301C82.0835 276.366 82.8892 275.692 82.955 274.771Z",
    fill: "url(#paint368_linear_935_10)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M82.955 274.771C83.0207 273.867 82.3466 273.061 81.4258 272.995C80.5214 272.929 79.7157 273.604 79.6499 274.525C79.5842 275.429 80.2583 276.235 81.1791 276.301C82.0835 276.366 82.8892 275.692 82.955 274.771Z",
    fill: "url(#paint369_linear_935_10)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1444 267.075C75.2102 266.171 74.536 265.365 73.6152 265.299C72.7109 265.233 71.9052 265.908 71.8394 266.829C71.7736 267.733 72.4478 268.539 73.3686 268.605C74.2729 268.67 75.0787 267.996 75.1444 267.075Z",
    fill: "url(#paint370_linear_935_10)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1444 267.075C75.2102 266.171 74.536 265.365 73.6152 265.299C72.7109 265.233 71.9052 265.908 71.8394 266.829C71.7736 267.733 72.4478 268.539 73.3686 268.605C74.2729 268.67 75.0787 267.996 75.1444 267.075Z",
    fill: "url(#paint371_linear_935_10)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1444 267.075C75.2102 266.171 74.536 265.365 73.6152 265.299C72.7109 265.233 71.9052 265.908 71.8394 266.829C71.7736 267.733 72.4478 268.539 73.3686 268.605C74.2729 268.67 75.0787 267.996 75.1444 267.075Z",
    fill: "url(#paint372_linear_935_10)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2982 273.505C66.364 272.601 65.6898 271.795 64.769 271.729C63.8647 271.663 63.059 272.337 62.9932 273.258C62.9274 274.163 63.6016 274.969 64.5224 275.034C65.4432 275.1 66.2325 274.426 66.2982 273.505Z",
    fill: "url(#paint373_linear_935_10)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2982 273.505C66.364 272.601 65.6898 271.795 64.769 271.729C63.8647 271.663 63.059 272.337 62.9932 273.258C62.9274 274.163 63.6016 274.969 64.5224 275.034C65.4432 275.1 66.2325 274.426 66.2982 273.505Z",
    fill: "url(#paint374_linear_935_10)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2982 273.505C66.364 272.601 65.6898 271.795 64.769 271.729C63.8647 271.663 63.059 272.337 62.9932 273.258C62.9274 274.163 63.6016 274.969 64.5224 275.034C65.4432 275.1 66.2325 274.426 66.2982 273.505Z",
    fill: "url(#paint375_linear_935_10)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4877 265.809C58.5535 264.905 57.8793 264.099 56.9585 264.033C56.0541 263.967 55.2484 264.641 55.1827 265.562C55.1169 266.467 55.791 267.273 56.7118 267.338C57.6327 267.404 58.4219 266.73 58.4877 265.809Z",
    fill: "url(#paint376_linear_935_10)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4877 265.809C58.5535 264.905 57.8793 264.099 56.9585 264.033C56.0541 263.967 55.2484 264.641 55.1827 265.562C55.1169 266.467 55.791 267.273 56.7118 267.338C57.6327 267.404 58.4219 266.73 58.4877 265.809Z",
    fill: "url(#paint377_linear_935_10)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4877 265.809C58.5535 264.905 57.8793 264.099 56.9585 264.033C56.0541 263.967 55.2484 264.641 55.1827 265.562C55.1169 266.467 55.791 267.273 56.7118 267.338C57.6327 267.404 58.4219 266.73 58.4877 265.809Z",
    fill: "url(#paint378_linear_935_10)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6415 272.255C49.7073 271.351 49.0331 270.545 48.1123 270.479C47.2079 270.413 46.4022 271.088 46.3365 272.009C46.2707 272.913 46.9449 273.719 47.8657 273.785C48.77 273.85 49.5757 273.176 49.6415 272.255Z",
    fill: "url(#paint379_linear_935_10)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6415 272.255C49.7073 271.351 49.0331 270.545 48.1123 270.479C47.2079 270.413 46.4022 271.088 46.3365 272.009C46.2707 272.913 46.9449 273.719 47.8657 273.785C48.77 273.85 49.5757 273.176 49.6415 272.255Z",
    fill: "url(#paint380_linear_935_10)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6415 272.255C49.7073 271.351 49.0331 270.545 48.1123 270.479C47.2079 270.413 46.4022 271.088 46.3365 272.009C46.2707 272.913 46.9449 273.719 47.8657 273.785C48.77 273.85 49.5757 273.176 49.6415 272.255Z",
    fill: "url(#paint381_linear_935_10)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9848 270.989C32.9848 270.989 32.9848 270.89 32.9848 270.857C32.1791 271.334 31.3898 271.844 30.6006 272.354C30.7815 272.453 30.9952 272.502 31.209 272.518C32.1133 272.584 32.919 271.91 32.9848 270.989Z",
    fill: "url(#paint382_linear_935_10)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9848 270.989C32.9848 270.989 32.9848 270.89 32.9848 270.857C32.1791 271.334 31.3898 271.844 30.6006 272.354C30.7815 272.453 30.9952 272.502 31.209 272.518C32.1133 272.584 32.919 271.91 32.9848 270.989Z",
    fill: "url(#paint383_linear_935_10)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9848 270.989C32.9848 270.989 32.9848 270.89 32.9848 270.857C32.1791 271.334 31.3898 271.844 30.6006 272.354C30.7815 272.453 30.9952 272.502 31.209 272.518C32.1133 272.584 32.919 271.91 32.9848 270.989Z",
    fill: "url(#paint384_linear_935_10)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M231.089 247.49C299.425 247.49 354.823 192.087 354.823 123.745C354.823 55.4025 299.425 0 231.089 0C162.753 0 107.356 55.4025 107.356 123.745C107.356 192.087 162.753 247.49 231.089 247.49Z",
    fill: "url(#paint385_linear_935_10)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M231.089 247.49C299.425 247.49 354.823 192.087 354.823 123.745C354.823 55.4025 299.425 0 231.089 0C162.753 0 107.356 55.4025 107.356 123.745C107.356 192.087 162.753 247.49 231.089 247.49Z",
    fill: "url(#paint386_linear_935_10)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9239 2.4502C33.0011 2.4502 18.4819 16.9707 18.4819 34.8952C18.4819 52.8197 33.0011 67.3402 50.9239 67.3402C68.8467 67.3402 83.3659 52.8197 83.3659 34.8952C83.3659 16.9707 68.8303 2.4502 50.9239 2.4502Z",
    fill: "url(#paint387_linear_935_10)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9239 2.4502C33.0011 2.4502 18.4819 16.9707 18.4819 34.8952C18.4819 52.8197 33.0011 67.3402 50.9239 67.3402C68.8467 67.3402 83.3659 52.8197 83.3659 34.8952C83.3659 16.9707 68.8303 2.4502 50.9239 2.4502Z",
    fill: "url(#paint388_linear_935_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_10",
    x1: 142.294,
    y1: 349.753,
    x2: 373.243,
    y2: 521.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_10",
    x1: 134.768,
    y1: 343.007,
    x2: 133.541,
    y2: 343.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_935_10",
    x1: 133.034,
    y1: 343.636,
    x2: 134.384,
    y2: 343.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_935_10",
    x1: 149.489,
    y1: 340.09,
    x2: 380.424,
    y2: 511.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_935_10",
    x1: 136.083,
    y1: 328.952,
    x2: 134.683,
    y2: 329.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_935_10",
    x1: 134.104,
    y1: 329.654,
    x2: 135.644,
    y2: 329.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_935_10",
    x1: 129.092,
    y1: 367.521,
    x2: 360.045,
    y2: 539.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_935_10",
    x1: 127.244,
    y1: 363.652,
    x2: 124.453,
    y2: 364.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_935_10",
    x1: 123.137,
    y1: 364.358,
    x2: 126.332,
    y2: 364.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_935_10",
    x1: 136.235,
    y1: 357.903,
    x2: 367.185,
    y2: 529.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_935_10",
    x1: 128.556,
    y1: 349.511,
    x2: 125.618,
    y2: 350.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_935_10",
    x1: 124.206,
    y1: 350.218,
    x2: 127.59,
    y2: 350.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_935_10",
    x1: 143.376,
    y1: 348.302,
    x2: 374.343,
    y2: 520.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_935_10",
    x1: 129.624,
    y1: 335.385,
    x2: 126.686,
    y2: 336.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_935_10",
    x1: 125.274,
    y1: 336.092,
    x2: 128.659,
    y2: 336.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_935_10",
    x1: 150.519,
    y1: 338.684,
    x2: 381.47,
    y2: 510.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_935_10",
    x1: 130.677,
    y1: 321.259,
    x2: 127.739,
    y2: 321.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_935_10",
    x1: 126.327,
    y1: 321.966,
    x2: 129.712,
    y2: 321.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_935_10",
    x1: 157.677,
    y1: 329.083,
    x2: 388.612,
    y2: 500.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_935_10",
    x1: 131.746,
    y1: 307.133,
    x2: 128.808,
    y2: 307.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_935_10",
    x1: 127.396,
    y1: 307.84,
    x2: 130.78,
    y2: 307.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_935_10",
    x1: 122.849,
    y1: 375.921,
    x2: 353.799,
    y2: 547.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_935_10",
    x1: 118.591,
    y1: 370.066,
    x2: 115.653,
    y2: 370.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_935_10",
    x1: 114.241,
    y1: 370.774,
    x2: 117.626,
    y2: 370.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_935_10",
    x1: 129.992,
    y1: 366.303,
    x2: 360.943,
    y2: 538.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_935_10",
    x1: 119.66,
    y1: 355.94,
    x2: 116.722,
    y2: 356.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_935_10",
    x1: 115.31,
    y1: 356.648,
    x2: 118.695,
    y2: 356.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_935_10",
    x1: 137.134,
    y1: 356.702,
    x2: 368.087,
    y2: 528.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_935_10",
    x1: 120.729,
    y1: 341.815,
    x2: 117.791,
    y2: 342.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_935_10",
    x1: 116.379,
    y1: 342.522,
    x2: 119.764,
    y2: 342.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_935_10",
    x1: 144.277,
    y1: 347.084,
    x2: 375.227,
    y2: 518.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_935_10",
    x1: 121.798,
    y1: 327.689,
    x2: 118.86,
    y2: 328.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_935_10",
    x1: 117.448,
    y1: 328.396,
    x2: 120.832,
    y2: 328.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_935_10",
    x1: 151.434,
    y1: 337.483,
    x2: 382.384,
    y2: 509.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_935_10",
    x1: 122.866,
    y1: 313.563,
    x2: 119.928,
    y2: 314.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_935_10",
    x1: 118.516,
    y1: 314.27,
    x2: 121.901,
    y2: 314.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_935_10",
    x1: 158.577,
    y1: 327.865,
    x2: 389.511,
    y2: 499.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_935_10",
    x1: 123.935,
    y1: 299.437,
    x2: 120.997,
    y2: 300.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_935_10",
    x1: 119.585,
    y1: 300.144,
    x2: 122.97,
    y2: 300.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_935_10",
    x1: 116.626,
    y1: 384.289,
    x2: 347.576,
    y2: 556.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_935_10",
    x1: 109.745,
    y1: 376.512,
    x2: 106.807,
    y2: 377.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_935_10",
    x1: 105.395,
    y1: 377.22,
    x2: 108.78,
    y2: 377.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_935_10",
    x1: 123.767,
    y1: 374.688,
    x2: 354.717,
    y2: 546.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_935_10",
    x1: 110.83,
    y1: 362.387,
    x2: 107.892,
    y2: 363.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_935_10",
    x1: 106.48,
    y1: 363.094,
    x2: 109.865,
    y2: 363.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_935_10",
    x1: 130.91,
    y1: 365.07,
    x2: 361.861,
    y2: 536.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_935_10",
    x1: 111.899,
    y1: 348.261,
    x2: 108.961,
    y2: 348.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_935_10",
    x1: 107.549,
    y1: 348.968,
    x2: 110.933,
    y2: 348.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_935_10",
    x1: 138.052,
    y1: 355.468,
    x2: 369.003,
    y2: 527.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_935_10",
    x1: 112.968,
    y1: 334.135,
    x2: 110.03,
    y2: 334.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_935_10",
    x1: 108.618,
    y1: 334.842,
    x2: 112.002,
    y2: 334.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_935_10",
    x1: 145.194,
    y1: 345.85,
    x2: 376.161,
    y2: 517.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_935_10",
    x1: 114.02,
    y1: 320.009,
    x2: 111.082,
    y2: 320.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_935_10",
    x1: 109.67,
    y1: 320.717,
    x2: 113.055,
    y2: 320.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_935_10",
    x1: 152.336,
    y1: 336.249,
    x2: 383.286,
    y2: 507.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_935_10",
    x1: 115.089,
    y1: 305.883,
    x2: 112.151,
    y2: 306.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_935_10",
    x1: 110.739,
    y1: 306.591,
    x2: 114.123,
    y2: 306.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_935_10",
    x1: 159.495,
    y1: 326.632,
    x2: 390.429,
    y2: 498.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_935_10",
    x1: 116.157,
    y1: 291.757,
    x2: 113.22,
    y2: 292.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_935_10",
    x1: 111.808,
    y1: 292.465,
    x2: 115.192,
    y2: 292.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_935_10",
    x1: 110.383,
    y1: 392.689,
    x2: 341.317,
    y2: 564.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_935_10",
    x1: 100.865,
    y1: 382.942,
    x2: 97.9276,
    y2: 383.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_935_10",
    x1: 96.5156,
    y1: 383.65,
    x2: 99.9002,
    y2: 383.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_935_10",
    x1: 117.525,
    y1: 383.087,
    x2: 348.461,
    y2: 554.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_935_10",
    x1: 101.934,
    y1: 368.816,
    x2: 98.9964,
    y2: 369.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_935_10",
    x1: 97.5845,
    y1: 369.524,
    x2: 100.969,
    y2: 369.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_935_10",
    x1: 124.668,
    y1: 373.47,
    x2: 355.619,
    y2: 545.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_935_10",
    x1: 103.003,
    y1: 354.691,
    x2: 100.065,
    y2: 355.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_935_10",
    x1: 98.6533,
    y1: 355.398,
    x2: 102.038,
    y2: 355.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_935_10",
    x1: 131.809,
    y1: 363.868,
    x2: 362.759,
    y2: 535.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_935_10",
    x1: 104.072,
    y1: 340.565,
    x2: 101.134,
    y2: 341.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_935_10",
    x1: 99.7222,
    y1: 341.272,
    x2: 103.107,
    y2: 341.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_935_10",
    x1: 138.952,
    y1: 354.25,
    x2: 369.902,
    y2: 525.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_935_10",
    x1: 105.141,
    y1: 326.439,
    x2: 102.203,
    y2: 327.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_935_10",
    x1: 100.791,
    y1: 327.146,
    x2: 104.176,
    y2: 327.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_935_10",
    x1: 146.094,
    y1: 344.648,
    x2: 377.045,
    y2: 516.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_935_10",
    x1: 106.21,
    y1: 312.313,
    x2: 103.272,
    y2: 313.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_935_10",
    x1: 101.86,
    y1: 313.021,
    x2: 105.244,
    y2: 313.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_935_10",
    x1: 153.237,
    y1: 335.031,
    x2: 384.188,
    y2: 506.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_935_10",
    x1: 107.279,
    y1: 298.187,
    x2: 104.341,
    y2: 298.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_935_10",
    x1: 102.929,
    y1: 298.895,
    x2: 106.313,
    y2: 298.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_935_10",
    x1: 160.395,
    y1: 325.43,
    x2: 391.345,
    y2: 497.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_935_10",
    x1: 108.347,
    y1: 284.061,
    x2: 105.409,
    y2: 284.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_935_10",
    x1: 103.998,
    y1: 284.769,
    x2: 107.382,
    y2: 284.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_935_10",
    x1: 104.142,
    y1: 401.072,
    x2: 335.095,
    y2: 572.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_935_10",
    x1: 92.0193,
    y1: 389.372,
    x2: 89.0814,
    y2: 390.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_935_10",
    x1: 87.6694,
    y1: 390.079,
    x2: 91.0541,
    y2: 390.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_935_10",
    x1: 111.301,
    y1: 391.456,
    x2: 342.236,
    y2: 563.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_935_10",
    x1: 93.0881,
    y1: 375.246,
    x2: 90.1502,
    y2: 375.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_935_10",
    x1: 88.7383,
    y1: 375.954,
    x2: 92.1229,
    y2: 375.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_935_10",
    x1: 118.443,
    y1: 381.854,
    x2: 349.393,
    y2: 553.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_935_10",
    x1: 94.157,
    y1: 361.12,
    x2: 91.2191,
    y2: 361.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_935_10",
    x1: 89.8071,
    y1: 361.828,
    x2: 93.1918,
    y2: 361.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_935_10",
    x1: 125.586,
    y1: 372.236,
    x2: 356.536,
    y2: 543.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_935_10",
    x1: 95.2258,
    y1: 346.995,
    x2: 92.2879,
    y2: 347.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_935_10",
    x1: 90.876,
    y1: 347.702,
    x2: 94.2606,
    y2: 347.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_935_10",
    x1: 132.727,
    y1: 362.635,
    x2: 363.678,
    y2: 534.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_935_10",
    x1: 96.2947,
    y1: 332.869,
    x2: 93.3568,
    y2: 333.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_935_10",
    x1: 91.9448,
    y1: 333.576,
    x2: 95.3294,
    y2: 333.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_935_10",
    x1: 139.87,
    y1: 353.017,
    x2: 370.821,
    y2: 524.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_935_10",
    x1: 97.3631,
    y1: 318.743,
    x2: 94.4251,
    y2: 319.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_935_10",
    x1: 93.0132,
    y1: 319.45,
    x2: 96.3978,
    y2: 319.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_935_10",
    x1: 147.011,
    y1: 343.415,
    x2: 377.963,
    y2: 515.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_935_10",
    x1: 98.4319,
    y1: 304.617,
    x2: 95.494,
    y2: 305.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_935_10",
    x1: 94.082,
    y1: 305.324,
    x2: 97.4666,
    y2: 305.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_935_10",
    x1: 154.154,
    y1: 333.797,
    x2: 385.104,
    y2: 505.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_935_10",
    x1: 99.5008,
    y1: 290.491,
    x2: 96.5628,
    y2: 291.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_935_10",
    x1: 95.1509,
    y1: 291.199,
    x2: 98.5355,
    y2: 291.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_935_10",
    x1: 98.2106,
    y1: 409.067,
    x2: 329.163,
    y2: 580.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_935_10",
    x1: 82.7292,
    y1: 395.178,
    x2: 80.6434,
    y2: 396.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_935_10",
    x1: 78.8442,
    y1: 395.448,
    x2: 81.8671,
    y2: 395.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_935_10",
    x1: 105.042,
    y1: 399.854,
    x2: 335.992,
    y2: 571.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_935_10",
    x1: 84.2088,
    y1: 381.676,
    x2: 81.2708,
    y2: 382.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_935_10",
    x1: 79.8589,
    y1: 382.383,
    x2: 83.2435,
    y2: 382.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_935_10",
    x1: 112.2,
    y1: 390.254,
    x2: 343.135,
    y2: 561.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_935_10",
    x1: 85.2776,
    y1: 367.55,
    x2: 82.3397,
    y2: 368.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_935_10",
    x1: 80.9277,
    y1: 368.258,
    x2: 84.3123,
    y2: 368.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_935_10",
    x1: 119.343,
    y1: 380.636,
    x2: 350.277,
    y2: 552.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_935_10",
    x1: 86.3465,
    y1: 353.424,
    x2: 83.4085,
    y2: 354.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_935_10",
    x1: 81.9966,
    y1: 354.132,
    x2: 85.3812,
    y2: 354.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_935_10",
    x1: 126.484,
    y1: 371.035,
    x2: 357.437,
    y2: 542.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_935_10",
    x1: 87.4153,
    y1: 339.299,
    x2: 84.4774,
    y2: 340.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_935_10",
    x1: 83.0654,
    y1: 340.006,
    x2: 86.45,
    y2: 340.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_935_10",
    x1: 133.627,
    y1: 361.416,
    x2: 364.578,
    y2: 533.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_935_10",
    x1: 88.4842,
    y1: 325.173,
    x2: 85.5462,
    y2: 325.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_935_10",
    x1: 84.1343,
    y1: 325.88,
    x2: 87.5189,
    y2: 325.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_935_10",
    x1: 140.769,
    y1: 351.815,
    x2: 371.72,
    y2: 523.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_935_10",
    x1: 89.553,
    y1: 311.047,
    x2: 86.6151,
    y2: 311.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_935_10",
    x1: 85.2031,
    y1: 311.754,
    x2: 88.5877,
    y2: 311.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_935_10",
    x1: 147.912,
    y1: 342.197,
    x2: 378.862,
    y2: 513.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_935_10",
    x1: 90.6218,
    y1: 296.921,
    x2: 87.6839,
    y2: 297.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_935_10",
    x1: 86.272,
    y1: 297.628,
    x2: 89.6566,
    y2: 297.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_935_10",
    x1: 155.053,
    y1: 332.596,
    x2: 386.006,
    y2: 504.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_935_10",
    x1: 91.6907,
    y1: 282.795,
    x2: 88.7528,
    y2: 283.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_935_10",
    x1: 87.3408,
    y1: 283.503,
    x2: 90.7254,
    y2: 283.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_935_10",
    x1: 98.8173,
    y1: 408.239,
    x2: 329.769,
    y2: 579.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_935_10",
    x1: 75.3626,
    y1: 388.106,
    x2: 72.4246,
    y2: 388.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_935_10",
    x1: 71.0127,
    y1: 388.813,
    x2: 74.3973,
    y2: 388.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_935_10",
    x1: 105.96,
    y1: 398.621,
    x2: 336.91,
    y2: 570.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_935_10",
    x1: 76.4314,
    y1: 373.98,
    x2: 73.4935,
    y2: 374.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_935_10",
    x1: 72.0815,
    y1: 374.687,
    x2: 75.4662,
    y2: 374.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_935_10",
    x1: 113.102,
    y1: 389.019,
    x2: 344.054,
    y2: 560.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_935_10",
    x1: 77.5003,
    y1: 359.854,
    x2: 74.5623,
    y2: 360.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_935_10",
    x1: 73.1504,
    y1: 360.562,
    x2: 76.535,
    y2: 360.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_935_10",
    x1: 120.261,
    y1: 379.402,
    x2: 351.195,
    y2: 551.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_935_10",
    x1: 78.5691,
    y1: 345.728,
    x2: 75.6312,
    y2: 346.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_935_10",
    x1: 74.2192,
    y1: 346.436,
    x2: 77.6039,
    y2: 346.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_935_10",
    x1: 127.403,
    y1: 369.801,
    x2: 358.353,
    y2: 541.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_935_10",
    x1: 79.638,
    y1: 331.603,
    x2: 76.7,
    y2: 332.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_935_10",
    x1: 75.2881,
    y1: 332.31,
    x2: 78.6727,
    y2: 332.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_935_10",
    x1: 134.545,
    y1: 360.183,
    x2: 365.496,
    y2: 531.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_935_10",
    x1: 80.7068,
    y1: 317.477,
    x2: 77.7689,
    y2: 318.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_935_10",
    x1: 76.3569,
    y1: 318.184,
    x2: 79.7416,
    y2: 318.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_935_10",
    x1: 141.686,
    y1: 350.582,
    x2: 372.639,
    y2: 522.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_935_10",
    x1: 81.7752,
    y1: 303.351,
    x2: 78.8372,
    y2: 304.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_935_10",
    x1: 77.4253,
    y1: 304.058,
    x2: 80.8099,
    y2: 304.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_935_10",
    x1: 148.829,
    y1: 340.963,
    x2: 379.779,
    y2: 512.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_935_10",
    x1: 82.844,
    y1: 289.225,
    x2: 79.9061,
    y2: 289.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_935_10",
    x1: 78.4941,
    y1: 289.932,
    x2: 81.8788,
    y2: 289.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_935_10",
    x1: 92.576,
    y1: 416.622,
    x2: 323.526,
    y2: 588.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_935_10",
    x1: 66.4836,
    y1: 394.551,
    x2: 63.5459,
    y2: 395.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_935_10",
    x1: 62.1333,
    y1: 395.257,
    x2: 65.5182,
    y2: 395.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_935_10",
    x1: 99.7174,
    y1: 407.021,
    x2: 330.685,
    y2: 578.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_935_10",
    x1: 67.552,
    y1: 380.41,
    x2: 64.6141,
    y2: 381.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_935_10",
    x1: 63.2021,
    y1: 381.117,
    x2: 66.5868,
    y2: 381.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_935_10",
    x1: 106.859,
    y1: 397.419,
    x2: 337.809,
    y2: 569.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_935_10",
    x1: 68.6209,
    y1: 366.284,
    x2: 65.6829,
    y2: 367.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_935_10",
    x1: 64.271,
    y1: 366.991,
    x2: 67.6556,
    y2: 366.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_935_10",
    x1: 114.018,
    y1: 387.802,
    x2: 344.952,
    y2: 559.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_935_10",
    x1: 69.6897,
    y1: 352.158,
    x2: 66.7518,
    y2: 352.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_935_10",
    x1: 65.3398,
    y1: 352.866,
    x2: 68.7245,
    y2: 352.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_935_10",
    x1: 121.161,
    y1: 378.184,
    x2: 352.095,
    y2: 549.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_935_10",
    x1: 70.7586,
    y1: 338.032,
    x2: 67.8206,
    y2: 338.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_935_10",
    x1: 66.4087,
    y1: 338.74,
    x2: 69.7933,
    y2: 338.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_935_10",
    x1: 128.303,
    y1: 368.583,
    x2: 359.254,
    y2: 540.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_935_10",
    x1: 71.8274,
    y1: 323.906,
    x2: 68.8895,
    y2: 324.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_935_10",
    x1: 67.4775,
    y1: 324.614,
    x2: 70.8622,
    y2: 324.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_935_10",
    x1: 135.444,
    y1: 358.981,
    x2: 366.395,
    y2: 530.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_935_10",
    x1: 72.8963,
    y1: 309.781,
    x2: 69.9583,
    y2: 310.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_935_10",
    x1: 68.5464,
    y1: 310.488,
    x2: 71.931,
    y2: 310.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_935_10",
    x1: 142.587,
    y1: 349.363,
    x2: 373.537,
    y2: 521.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_935_10",
    x1: 73.9651,
    y1: 295.655,
    x2: 71.0272,
    y2: 296.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_935_10",
    x1: 69.6152,
    y1: 296.362,
    x2: 72.9998,
    y2: 296.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_935_10",
    x1: 149.729,
    y1: 339.762,
    x2: 380.679,
    y2: 511.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_935_10",
    x1: 75.0339,
    y1: 281.529,
    x2: 72.096,
    y2: 282.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_935_10",
    x1: 70.6841,
    y1: 282.236,
    x2: 74.0687,
    y2: 282.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_935_10",
    x1: 93.4925,
    y1: 415.405,
    x2: 324.445,
    y2: 587.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_935_10",
    x1: 58.7058,
    y1: 386.856,
    x2: 55.7679,
    y2: 387.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_935_10",
    x1: 54.356,
    y1: 387.563,
    x2: 57.7406,
    y2: 387.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_935_10",
    x1: 100.635,
    y1: 405.787,
    x2: 331.587,
    y2: 577.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_935_10",
    x1: 59.7747,
    y1: 372.73,
    x2: 56.8367,
    y2: 373.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_935_10",
    x1: 55.4248,
    y1: 373.438,
    x2: 58.8094,
    y2: 373.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_935_10",
    x1: 107.777,
    y1: 396.186,
    x2: 338.728,
    y2: 567.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_935_10",
    x1: 60.8435,
    y1: 358.604,
    x2: 57.9056,
    y2: 359.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_935_10",
    x1: 56.4937,
    y1: 359.312,
    x2: 59.8783,
    y2: 359.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_935_10",
    x1: 114.92,
    y1: 386.568,
    x2: 345.87,
    y2: 558.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_935_10",
    x1: 61.9124,
    y1: 344.479,
    x2: 58.9744,
    y2: 345.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_935_10",
    x1: 57.5625,
    y1: 345.186,
    x2: 60.9471,
    y2: 345.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_935_10",
    x1: 122.078,
    y1: 376.968,
    x2: 353.014,
    y2: 548.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_935_10",
    x1: 62.9812,
    y1: 330.353,
    x2: 60.0433,
    y2: 331.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_935_10",
    x1: 58.6313,
    y1: 331.06,
    x2: 62.016,
    y2: 331.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_935_10",
    x1: 129.221,
    y1: 367.35,
    x2: 360.172,
    y2: 539.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_935_10",
    x1: 64.0501,
    y1: 316.227,
    x2: 61.1121,
    y2: 316.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_935_10",
    x1: 59.7002,
    y1: 316.934,
    x2: 63.0848,
    y2: 316.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_935_10",
    x1: 136.362,
    y1: 357.748,
    x2: 367.312,
    y2: 529.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_935_10",
    x1: 65.1184,
    y1: 302.101,
    x2: 62.1805,
    y2: 302.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_935_10",
    x1: 60.7686,
    y1: 302.808,
    x2: 64.1532,
    y2: 302.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_935_10",
    x1: 143.505,
    y1: 348.13,
    x2: 374.455,
    y2: 519.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_935_10",
    x1: 66.1873,
    y1: 287.975,
    x2: 63.2493,
    y2: 288.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_935_10",
    x1: 61.8374,
    y1: 288.683,
    x2: 65.222,
    y2: 288.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_935_10",
    x1: 87.6367,
    y1: 423.273,
    x2: 318.571,
    y2: 594.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_935_10",
    x1: 49.7792,
    y1: 392.887,
    x2: 47.2077,
    y2: 393.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_935_10",
    x1: 45.6294,
    y1: 393.309,
    x2: 48.8583,
    y2: 393.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_935_10",
    x1: 94.3926,
    y1: 414.187,
    x2: 325.343,
    y2: 585.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_935_10",
    x1: 50.8953,
    y1: 379.16,
    x2: 47.9573,
    y2: 379.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_935_10",
    x1: 46.5454,
    y1: 379.867,
    x2: 49.93,
    y2: 379.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_935_10",
    x1: 101.535,
    y1: 404.569,
    x2: 332.486,
    y2: 576.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_935_10",
    x1: 51.9641,
    y1: 365.034,
    x2: 49.0262,
    y2: 365.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_935_10",
    x1: 47.6143,
    y1: 365.742,
    x2: 50.9989,
    y2: 365.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_935_10",
    x1: 108.677,
    y1: 394.968,
    x2: 339.629,
    y2: 566.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_935_10",
    x1: 53.033,
    y1: 350.908,
    x2: 50.095,
    y2: 351.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_935_10",
    x1: 48.6831,
    y1: 351.616,
    x2: 52.0677,
    y2: 351.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_935_10",
    x1: 115.835,
    y1: 385.367,
    x2: 346.771,
    y2: 557.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_935_10",
    x1: 54.1018,
    y1: 336.783,
    x2: 51.1639,
    y2: 337.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_935_10",
    x1: 49.752,
    y1: 337.49,
    x2: 53.1366,
    y2: 337.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_935_10",
    x1: 122.978,
    y1: 375.749,
    x2: 353.928,
    y2: 547.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_935_10",
    x1: 55.1541,
    y1: 322.657,
    x2: 52.2161,
    y2: 323.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_935_10",
    x1: 50.8042,
    y1: 323.364,
    x2: 54.1888,
    y2: 323.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_935_10",
    x1: 130.121,
    y1: 366.131,
    x2: 361.055,
    y2: 537.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_935_10",
    x1: 56.2229,
    y1: 308.531,
    x2: 53.285,
    y2: 309.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_935_10",
    x1: 51.873,
    y1: 309.238,
    x2: 55.2577,
    y2: 309.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_935_10",
    x1: 137.262,
    y1: 356.53,
    x2: 368.197,
    y2: 528.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_935_10",
    x1: 57.2918,
    y1: 294.405,
    x2: 54.3538,
    y2: 295.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_935_10",
    x1: 52.9419,
    y1: 295.112,
    x2: 56.3265,
    y2: 295.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_935_10",
    x1: 144.404,
    y1: 346.929,
    x2: 375.357,
    y2: 518.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_935_10",
    x1: 58.3772,
    y1: 280.279,
    x2: 55.4393,
    y2: 281.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_935_10",
    x1: 54.0273,
    y1: 280.987,
    x2: 57.412,
    y2: 280.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_935_10",
    x1: 88.1691,
    y1: 422.555,
    x2: 319.103,
    y2: 594.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_935_10",
    x1: 42.0491,
    y1: 385.59,
    x2: 39.1112,
    y2: 386.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_935_10",
    x1: 37.6992,
    y1: 386.297,
    x2: 41.0838,
    y2: 386.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_935_10",
    x1: 95.3107,
    y1: 412.954,
    x2: 326.246,
    y2: 584.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_935_10",
    x1: 43.1179,
    y1: 371.464,
    x2: 40.18,
    y2: 372.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_935_10",
    x1: 38.7681,
    y1: 372.171,
    x2: 42.1527,
    y2: 372.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_935_10",
    x1: 102.452,
    y1: 403.352,
    x2: 333.405,
    y2: 575.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_935_10",
    x1: 44.1868,
    y1: 357.338,
    x2: 41.2488,
    y2: 358.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_935_10",
    x1: 39.8369,
    y1: 358.046,
    x2: 43.2215,
    y2: 358.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_935_10",
    x1: 109.595,
    y1: 393.734,
    x2: 340.545,
    y2: 565.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_935_10",
    x1: 45.2556,
    y1: 343.212,
    x2: 42.3177,
    y2: 343.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_935_10",
    x1: 40.9058,
    y1: 343.92,
    x2: 44.2904,
    y2: 343.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_935_10",
    x1: 116.737,
    y1: 384.133,
    x2: 347.688,
    y2: 555.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_935_10",
    x1: 46.3245,
    y1: 329.086,
    x2: 43.3865,
    y2: 329.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_935_10",
    x1: 41.9746,
    y1: 329.794,
    x2: 45.3592,
    y2: 329.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_935_10",
    x1: 123.896,
    y1: 374.516,
    x2: 354.831,
    y2: 546.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_935_10",
    x1: 47.3933,
    y1: 314.961,
    x2: 44.4554,
    y2: 315.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_935_10",
    x1: 43.0435,
    y1: 315.668,
    x2: 46.4281,
    y2: 315.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_935_10",
    x1: 131.037,
    y1: 364.915,
    x2: 361.973,
    y2: 536.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_935_10",
    x1: 48.4617,
    y1: 300.835,
    x2: 45.5238,
    y2: 301.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_935_10",
    x1: 44.1118,
    y1: 301.542,
    x2: 47.4964,
    y2: 301.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_935_10",
    x1: 138.18,
    y1: 355.296,
    x2: 369.13,
    y2: 527.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_935_10",
    x1: 49.5305,
    y1: 286.709,
    x2: 46.5926,
    y2: 287.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_935_10",
    x1: 45.1807,
    y1: 287.416,
    x2: 48.5653,
    y2: 287.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_935_10",
    x1: 89.068,
    y1: 421.354,
    x2: 320.019,
    y2: 593.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_935_10",
    x1: 34.2385,
    y1: 377.894,
    x2: 31.3006,
    y2: 378.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_935_10",
    x1: 29.8887,
    y1: 378.601,
    x2: 33.2733,
    y2: 378.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_935_10",
    x1: 96.2108,
    y1: 411.735,
    x2: 327.16,
    y2: 583.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_935_10",
    x1: 35.3074,
    y1: 363.768,
    x2: 32.3695,
    y2: 364.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_935_10",
    x1: 30.9575,
    y1: 364.475,
    x2: 34.3421,
    y2: 364.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_935_10",
    x1: 103.352,
    y1: 402.134,
    x2: 334.303,
    y2: 573.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_935_10",
    x1: 36.3762,
    y1: 349.642,
    x2: 33.4383,
    y2: 350.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_935_10",
    x1: 32.0264,
    y1: 350.35,
    x2: 35.411,
    y2: 350.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_935_10",
    x1: 110.495,
    y1: 392.516,
    x2: 341.447,
    y2: 564.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_935_10",
    x1: 37.4451,
    y1: 335.516,
    x2: 34.5071,
    y2: 336.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_935_10",
    x1: 33.0952,
    y1: 336.224,
    x2: 36.4798,
    y2: 336.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_935_10",
    x1: 117.653,
    y1: 382.916,
    x2: 348.605,
    y2: 554.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_935_10",
    x1: 38.4973,
    y1: 321.39,
    x2: 35.5594,
    y2: 322.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_935_10",
    x1: 34.1475,
    y1: 322.098,
    x2: 37.5321,
    y2: 322.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_935_10",
    x1: 124.795,
    y1: 373.314,
    x2: 355.746,
    y2: 545.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_935_10",
    x1: 39.5662,
    y1: 307.265,
    x2: 36.6282,
    y2: 307.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_935_10",
    x1: 35.2163,
    y1: 307.972,
    x2: 38.6009,
    y2: 307.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_935_10",
    x1: 131.938,
    y1: 363.696,
    x2: 362.871,
    y2: 535.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_935_10",
    x1: 40.635,
    y1: 293.139,
    x2: 37.6971,
    y2: 293.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_935_10",
    x1: 36.2852,
    y1: 293.846,
    x2: 39.6698,
    y2: 293.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_935_10",
    x1: 139.08,
    y1: 354.078,
    x2: 370.031,
    y2: 525.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_935_10",
    x1: 41.7039,
    y1: 279.013,
    x2: 38.7659,
    y2: 279.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_935_10",
    x1: 37.354,
    y1: 279.72,
    x2: 40.7386,
    y2: 279.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_935_10",
    x1: 89.986,
    y1: 420.12,
    x2: 320.936,
    y2: 591.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_935_10",
    x1: 26.4612,
    y1: 370.198,
    x2: 23.5233,
    y2: 370.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_935_10",
    x1: 22.1113,
    y1: 370.905,
    x2: 25.4959,
    y2: 370.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_935_10",
    x1: 97.1289,
    y1: 410.502,
    x2: 328.08,
    y2: 582.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_935_10",
    x1: 27.53,
    y1: 356.072,
    x2: 24.5921,
    y2: 356.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_935_10",
    x1: 23.1802,
    y1: 356.779,
    x2: 26.5648,
    y2: 356.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_935_10",
    x1: 104.27,
    y1: 400.901,
    x2: 335.222,
    y2: 572.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_935_10",
    x1: 28.5989,
    y1: 341.946,
    x2: 25.661,
    y2: 342.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_935_10",
    x1: 24.249,
    y1: 342.654,
    x2: 27.6336,
    y2: 342.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_935_10",
    x1: 111.412,
    y1: 391.299,
    x2: 342.362,
    y2: 563.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_935_10",
    x1: 29.6677,
    y1: 327.82,
    x2: 26.7298,
    y2: 328.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_935_10",
    x1: 25.3179,
    y1: 328.528,
    x2: 28.7025,
    y2: 328.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_935_10",
    x1: 118.555,
    y1: 381.681,
    x2: 349.505,
    y2: 553.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_935_10",
    x1: 30.7366,
    y1: 313.694,
    x2: 27.7987,
    y2: 314.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_935_10",
    x1: 26.3867,
    y1: 314.402,
    x2: 29.7713,
    y2: 314.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_935_10",
    x1: 125.696,
    y1: 372.079,
    x2: 356.648,
    y2: 543.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_935_10",
    x1: 31.8054,
    y1: 299.569,
    x2: 28.8675,
    y2: 300.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_935_10",
    x1: 27.4556,
    y1: 300.276,
    x2: 30.8402,
    y2: 300.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_935_10",
    x1: 132.855,
    y1: 362.463,
    x2: 363.807,
    y2: 534.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_935_10",
    x1: 32.8738,
    y1: 285.443,
    x2: 29.9359,
    y2: 286.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_935_10",
    x1: 28.5239,
    y1: 286.15,
    x2: 31.9085,
    y2: 286.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_935_10",
    x1: 90.8864,
    y1: 418.902,
    x2: 321.837,
    y2: 590.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_935_10",
    x1: 18.6345,
    y1: 362.502,
    x2: 15.6966,
    y2: 363.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_935_10",
    x1: 14.2847,
    y1: 363.209,
    x2: 17.6693,
    y2: 363.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_935_10",
    x1: 98.028,
    y1: 409.3,
    x2: 328.978,
    y2: 581.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_935_10",
    x1: 15.3535,
    y1: 349.083,
    x2: 18.7381,
    y2: 349.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_935_10",
    x1: 19.7034,
    y1: 348.376,
    x2: 16.7655,
    y2: 349.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_935_10",
    x1: 15.3535,
    y1: 349.083,
    x2: 18.7381,
    y2: 349.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_935_10",
    x1: 105.17,
    y1: 399.682,
    x2: 336.119,
    y2: 571.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_935_10",
    x1: 16.4219,
    y1: 334.957,
    x2: 19.8065,
    y2: 334.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_935_10",
    x1: 20.7717,
    y1: 334.25,
    x2: 17.8338,
    y2: 334.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_935_10",
    x1: 16.4219,
    y1: 334.957,
    x2: 19.8065,
    y2: 334.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_935_10",
    x1: 112.312,
    y1: 390.081,
    x2: 343.262,
    y2: 561.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_935_10",
    x1: 17.4907,
    y1: 320.832,
    x2: 20.8753,
    y2: 320.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_935_10",
    x1: 21.8406,
    y1: 320.124,
    x2: 18.9027,
    y2: 320.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_935_10",
    x1: 17.4907,
    y1: 320.832,
    x2: 20.8753,
    y2: 320.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_935_10",
    x1: 119.455,
    y1: 380.463,
    x2: 350.406,
    y2: 552.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_935_10",
    x1: 22.9094,
    y1: 305.998,
    x2: 19.9715,
    y2: 306.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_935_10",
    x1: 18.5596,
    y1: 306.706,
    x2: 21.9442,
    y2: 306.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_935_10",
    x1: 126.613,
    y1: 370.862,
    x2: 357.563,
    y2: 542.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_935_10",
    x1: 23.9783,
    y1: 291.873,
    x2: 21.0404,
    y2: 292.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_935_10",
    x1: 19.6284,
    y1: 292.58,
    x2: 23.013,
    y2: 292.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_935_10",
    x1: 133.719,
    y1: 361.291,
    x2: 364.669,
    y2: 533.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_935_10",
    x1: 24.862,
    y1: 278.257,
    x2: 22.4664,
    y2: 278.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_935_10",
    x1: 21.2935,
    y1: 278.809,
    x2: 24.0701,
    y2: 278.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_935_10",
    x1: 91.8042,
    y1: 417.668,
    x2: 322.754,
    y2: 589.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_935_10",
    x1: 10.8733,
    y1: 354.822,
    x2: 7.93537,
    y2: 355.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_935_10",
    x1: 6.52344,
    y1: 355.53,
    x2: 9.90806,
    y2: 355.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_935_10",
    x1: 98.9458,
    y1: 408.067,
    x2: 329.896,
    y2: 579.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_935_10",
    x1: 7.59229,
    y1: 341.404,
    x2: 10.9769,
    y2: 341.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_935_10",
    x1: 11.9422,
    y1: 340.696,
    x2: 9.00422,
    y2: 341.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_935_10",
    x1: 7.59229,
    y1: 341.404,
    x2: 10.9769,
    y2: 341.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_935_10",
    x1: 106.089,
    y1: 398.449,
    x2: 337.039,
    y2: 570.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_935_10",
    x1: 8.66113,
    y1: 327.278,
    x2: 12.0458,
    y2: 327.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_935_10",
    x1: 13.011,
    y1: 326.57,
    x2: 10.0731,
    y2: 327.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_935_10",
    x1: 8.66113,
    y1: 327.278,
    x2: 12.0458,
    y2: 327.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_935_10",
    x1: 113.23,
    y1: 388.848,
    x2: 344.182,
    y2: 560.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_935_10",
    x1: 9.72998,
    y1: 313.152,
    x2: 13.1146,
    y2: 313.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_935_10",
    x1: 14.0798,
    y1: 312.445,
    x2: 11.1419,
    y2: 313.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_935_10",
    x1: 9.72998,
    y1: 313.152,
    x2: 13.1146,
    y2: 313.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_935_10",
    x1: 120.372,
    y1: 379.246,
    x2: 351.323,
    y2: 550.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_935_10",
    x1: 10.7988,
    y1: 299.026,
    x2: 14.1834,
    y2: 299.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_935_10",
    x1: 15.1487,
    y1: 298.319,
    x2: 12.2108,
    y2: 299.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_935_10",
    x1: 10.7988,
    y1: 299.026,
    x2: 14.1834,
    y2: 299.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_935_10",
    x1: 99.8459,
    y1: 406.849,
    x2: 330.797,
    y2: 578.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_935_10",
    x1: -1.04237e-8,
    y1: 333.708,
    x2: 3.14498,
    y2: 333.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_935_10",
    x1: 4.04189,
    y1: 333,
    x2: 1.29023,
    y2: 333.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_935_10",
    x1: -1.04237e-8,
    y1: 333.708,
    x2: 3.14498,
    y2: 333.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_935_10",
    x1: 106.987,
    y1: 397.248,
    x2: 337.939,
    y2: 568.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_935_10",
    x1: 0.833984,
    y1: 319.582,
    x2: 4.2186,
    y2: 319.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_935_10",
    x1: 5.18385,
    y1: 318.874,
    x2: 2.24592,
    y2: 319.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_935_10",
    x1: 0.833984,
    y1: 319.582,
    x2: 4.2186,
    y2: 319.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_935_10",
    x1: 114.222,
    y1: 387.504,
    x2: 345.157,
    y2: 559.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_935_10",
    x1: 3.56836,
    y1: 305.64,
    x2: 5.25093,
    y2: 305.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_935_10",
    x1: 5.73077,
    y1: 305.022,
    x2: 4.2109,
    y2: 305.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_935_10",
    x1: 3.56836,
    y1: 305.64,
    x2: 5.25093,
    y2: 305.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_935_10",
    x1: 161.882,
    y1: 323.432,
    x2: 392.815,
    y2: 495.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_935_10",
    x1: 100.652,
    y1: 275.247,
    x2: 97.7142,
    y2: 275.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_935_10",
    x1: 96.3022,
    y1: 275.955,
    x2: 99.6869,
    y2: 275.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_935_10",
    x1: 162.765,
    y1: 322.212,
    x2: 393.715,
    y2: 493.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_935_10",
    x1: 92.8416,
    y1: 267.551,
    x2: 89.9036,
    y2: 268.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_935_10",
    x1: 88.4917,
    y1: 268.259,
    x2: 91.8763,
    y2: 268.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_935_10",
    x1: 156.54,
    y1: 330.597,
    x2: 387.493,
    y2: 502.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_935_10",
    x1: 83.9954,
    y1: 273.981,
    x2: 81.0574,
    y2: 274.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_935_10",
    x1: 79.6455,
    y1: 274.688,
    x2: 83.0301,
    y2: 274.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_935_10",
    x1: 157.441,
    y1: 329.379,
    x2: 388.391,
    y2: 501.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_935_10",
    x1: 76.1848,
    y1: 266.285,
    x2: 73.2469,
    y2: 267.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_935_10",
    x1: 71.835,
    y1: 266.992,
    x2: 75.2196,
    y2: 266.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_935_10",
    x1: 151.216,
    y1: 337.763,
    x2: 382.166,
    y2: 509.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_935_10",
    x1: 67.3386,
    y1: 272.715,
    x2: 64.4007,
    y2: 273.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_935_10",
    x1: 62.9888,
    y1: 273.422,
    x2: 66.3734,
    y2: 273.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_935_10",
    x1: 152.116,
    y1: 336.546,
    x2: 383.067,
    y2: 508.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_935_10",
    x1: 59.5281,
    y1: 265.019,
    x2: 56.5902,
    y2: 265.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_935_10",
    x1: 55.1782,
    y1: 265.726,
    x2: 58.5628,
    y2: 265.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_935_10",
    x1: 145.891,
    y1: 344.93,
    x2: 376.844,
    y2: 516.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_935_10",
    x1: 50.6819,
    y1: 271.465,
    x2: 47.744,
    y2: 272.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_935_10",
    x1: 46.332,
    y1: 272.172,
    x2: 49.7166,
    y2: 272.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_935_10",
    x1: 140.366,
    y1: 352.345,
    x2: 371.301,
    y2: 524.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_935_10",
    x1: 33.7302,
    y1: 271.355,
    x2: 31.7373,
    y2: 272.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_935_10",
    x1: 30.6006,
    y1: 271.71,
    x2: 33.0357,
    y2: 271.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_935_10",
    x1: 175.496,
    y1: 277.402,
    x2: 269.236,
    y2: 18.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F28C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB5D14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_935_10",
    x1: 107.356,
    y1: 126.763,
    x2: 360.104,
    y2: 126.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_935_10",
    x1: 128.107,
    y1: -127.856,
    x2: 36.8512,
    y2: 64.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#403B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_935_10",
    x1: 103.65,
    y1: 21.8359,
    x2: 46.1267,
    y2: 36.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#455DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1750"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundsHolder);
export default __webpack_public_path__ + "static/media/rounds-holder.e8c114d9eb8eec03fefdd45027f092e3.svg";
export { ForwardRef as ReactComponent };